import '../../assets/index60.css';var ws = Object.defineProperty, Ms = Object.defineProperties;
var ks = Object.getOwnPropertyDescriptors;
var Oe = Object.getOwnPropertySymbols;
var Ft = Object.prototype.hasOwnProperty, zt = Object.prototype.propertyIsEnumerable;
var Yt = (t, e, a) => e in t ? ws(t, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[e] = a, _ = (t, e) => {
  for (var a in e || (e = {}))
    Ft.call(e, a) && Yt(t, a, e[a]);
  if (Oe)
    for (var a of Oe(e))
      zt.call(e, a) && Yt(t, a, e[a]);
  return t;
}, I = (t, e) => Ms(t, ks(e));
var j = (t, e) => {
  var a = {};
  for (var s in t)
    Ft.call(t, s) && e.indexOf(s) < 0 && (a[s] = t[s]);
  if (t != null && Oe)
    for (var s of Oe(t))
      e.indexOf(s) < 0 && zt.call(t, s) && (a[s] = t[s]);
  return a;
};
import { jsx as x, jsxs as ie, Fragment as Cs } from "react/jsx-runtime";
import { useState as ze, useEffect as Vt, createContext as Ls, useContext as Os, useCallback as $e, useRef as We, forwardRef as xs } from "react";
import { CalendarDayFarFAIcon as Ns, ChevronRightFAIcon as Ts, ChevronLeftFAIcon as As } from "../Icons/index.js";
import { Label as Ys } from "../Label/index.js";
import { g as Pe } from "../../_commonjsHelpers-lRDecupM.js";
import { u as Ut } from "../../use-uncontrolled-BT_j5D2R.js";
import { u as Fs } from "../../use-disclosure-Do3DbqlJ.js";
import { f as K, u as J, B as de, c as zs } from "../../factory-ueRxoNOV.js";
import { u as he } from "../../use-styles-DToiHEa6.js";
import { U as Me } from "../../UnstyledButton-D9OCzDhz.js";
import { r as ke } from "../../rem-CMQJ_ZTp.js";
import { c as ge } from "../../create-vars-resolver-Bzbn9G-G.js";
import { c as Ce, e as Ws, b as Ps, a as Re } from "../../get-size-Bc1Pz5yf.js";
import { u as He } from "../../use-resolved-styles-api-D-aL_8KF.js";
import { c as Rs } from "../../clamp-CqQfNxSP.js";
import { u as Hs } from "../../use-input-props-TH9VAmBb.js";
import { I as xe } from "../../Input--FNE961U.js";
import { g as Ie } from "../../OptionalPortal-sP4Hf4UO.js";
import { M as Is, a as Bs, N as Es, b as Vs, c as Us, d as Gs, e as js, f as Zs } from "../../NativeScrollArea-AK71H4_N.js";
import { c as Ks } from "../../create-safe-context-DqDyoPVE.js";
import { S as qs } from "../../ScrollArea-BFbb1tLv.js";
import { c as Js } from "../../create-optional-context-CQ2ahjKQ.js";
import { P as Dt } from "../../Popover-CchFr99F.js";
function gt(s) {
  var n = s, { style: t, size: e = 16 } = n, a = j(n, ["style", "size"]);
  return /* @__PURE__ */ x(
    "svg",
    I(_({
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: I(_({}, t), { width: ke(e), height: ke(e), display: "block" })
    }, a), {
      children: /* @__PURE__ */ x(
        "path",
        {
          d: "M3.13523 6.15803C3.3241 5.95657 3.64052 5.94637 3.84197 6.13523L7.5 9.56464L11.158 6.13523C11.3595 5.94637 11.6759 5.95657 11.8648 6.15803C12.0536 6.35949 12.0434 6.67591 11.842 6.86477L7.84197 10.6148C7.64964 10.7951 7.35036 10.7951 7.15803 10.6148L3.15803 6.86477C2.95657 6.67591 2.94637 6.35949 3.13523 6.15803Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    })
  );
}
gt.displayName = "@mantine/core/AccordionChevron";
const [Qs, be] = Ks(
  "Modal component was not found in tree"
);
var pe = { root: "m_9df02822", content: "m_54c44539", inner: "m_1f958f16", header: "m_d0e2b9cd" };
const Xs = {}, Be = K((t, e) => {
  const o = J("ModalBody", Xs, t), { classNames: s, className: n, style: l, styles: i, vars: c } = o, u = j(o, ["classNames", "className", "style", "styles", "vars"]), r = be();
  return /* @__PURE__ */ x(
    Is,
    _(_({
      ref: e
    }, r.getStyles("body", { classNames: s, style: l, styles: i, className: n })), u)
  );
});
Be.classes = pe;
Be.displayName = "@mantine/core/ModalBody";
const ea = {}, Ee = K((t, e) => {
  const o = J("ModalCloseButton", ea, t), { classNames: s, className: n, style: l, styles: i, vars: c } = o, u = j(o, ["classNames", "className", "style", "styles", "vars"]), r = be();
  return /* @__PURE__ */ x(
    Bs,
    _(_({
      ref: e
    }, r.getStyles("close", { classNames: s, style: l, styles: i, className: n })), u)
  );
});
Ee.classes = pe;
Ee.displayName = "@mantine/core/ModalCloseButton";
const ta = {}, Ve = K((t, e) => {
  const h = J("ModalContent", ta, t), { classNames: s, className: n, style: l, styles: i, vars: c, children: u, __hidden: r } = h, o = j(h, ["classNames", "className", "style", "styles", "vars", "children", "__hidden"]), D = be(), v = D.scrollAreaComponent || Es;
  return /* @__PURE__ */ x(
    Vs,
    I(_(I(_({}, D.getStyles("content", { className: n, style: l, styles: i, classNames: s })), {
      innerProps: D.getStyles("inner", { className: n, style: l, styles: i, classNames: s }),
      "data-full-screen": D.fullScreen || void 0,
      "data-modal-content": !0,
      "data-hidden": r || void 0,
      ref: e
    }), o), {
      children: /* @__PURE__ */ x(
        v,
        {
          style: {
            maxHeight: D.fullScreen ? "100dvh" : `calc(100dvh - (${ke(D.yOffset)} * 2))`
          },
          children: u
        }
      )
    })
  );
});
Ve.classes = pe;
Ve.displayName = "@mantine/core/ModalContent";
const sa = {}, Ue = K((t, e) => {
  const o = J("ModalHeader", sa, t), { classNames: s, className: n, style: l, styles: i, vars: c } = o, u = j(o, ["classNames", "className", "style", "styles", "vars"]), r = be();
  return /* @__PURE__ */ x(
    Us,
    _(_({
      ref: e
    }, r.getStyles("header", { classNames: s, style: l, styles: i, className: n })), u)
  );
});
Ue.classes = pe;
Ue.displayName = "@mantine/core/ModalHeader";
const aa = {}, Ge = K((t, e) => {
  const o = J("ModalOverlay", aa, t), { classNames: s, className: n, style: l, styles: i, vars: c } = o, u = j(o, ["classNames", "className", "style", "styles", "vars"]), r = be();
  return /* @__PURE__ */ x(
    Gs,
    _(_({
      ref: e
    }, r.getStyles("overlay", { classNames: s, style: l, styles: i, className: n })), u)
  );
});
Ge.classes = pe;
Ge.displayName = "@mantine/core/ModalOverlay";
const na = {
  __staticSelector: "Modal",
  closeOnClickOutside: !0,
  withinPortal: !0,
  lockScroll: !0,
  trapFocus: !0,
  returnFocus: !0,
  closeOnEscape: !0,
  keepMounted: !1,
  zIndex: Ie("modal"),
  transitionProps: { duration: 200, transition: "fade-down" },
  yOffset: "5dvh"
}, ra = ge(
  (t, { radius: e, size: a, yOffset: s, xOffset: n }) => ({
    root: {
      "--modal-radius": e === void 0 ? void 0 : Ws(e),
      "--modal-size": Ce(a, "modal-size"),
      "--modal-y-offset": ke(s),
      "--modal-x-offset": ke(n)
    }
  })
), je = K((t, e) => {
  const a = J("ModalRoot", na, t), N = a, {
    classNames: s,
    className: n,
    style: l,
    styles: i,
    unstyled: c,
    vars: u,
    yOffset: r,
    scrollAreaComponent: o,
    radius: D,
    fullScreen: v,
    centered: h,
    xOffset: d,
    __staticSelector: m
  } = N, b = j(N, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "yOffset",
    "scrollAreaComponent",
    "radius",
    "fullScreen",
    "centered",
    "xOffset",
    "__staticSelector"
  ]), k = he({
    name: m,
    classes: pe,
    props: a,
    className: n,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: u,
    varsResolver: ra
  });
  return /* @__PURE__ */ x(Qs, { value: { yOffset: r, scrollAreaComponent: o, getStyles: k, fullScreen: v }, children: /* @__PURE__ */ x(
    js,
    _(I(_({
      ref: e
    }, k("root")), {
      "data-full-screen": v || void 0,
      "data-centered": h || void 0,
      "data-offset-scrollbars": o === qs.Autosize || void 0,
      unstyled: c
    }), b)
  ) });
});
je.classes = pe;
je.displayName = "@mantine/core/ModalRoot";
const [oa, ia] = Js();
function Gt({ children: t }) {
  const [e, a] = ze([]), [s, n] = ze(Ie("modal"));
  return /* @__PURE__ */ x(
    oa,
    {
      value: {
        stack: e,
        addModal: (l, i) => {
          a((c) => [.../* @__PURE__ */ new Set([...c, l])]), n(
            (c) => typeof i == "number" && typeof c == "number" ? Math.max(c, i) : c
          );
        },
        removeModal: (l) => a((i) => i.filter((c) => c !== l)),
        getZIndex: (l) => `calc(${s} + ${e.indexOf(l)} + 1)`,
        currentId: e[e.length - 1],
        maxZIndex: s
      },
      children: t
    }
  );
}
Gt.displayName = "@mantine/core/ModalStack";
const la = {}, Ze = K((t, e) => {
  const o = J("ModalTitle", la, t), { classNames: s, className: n, style: l, styles: i, vars: c } = o, u = j(o, ["classNames", "className", "style", "styles", "vars"]), r = be();
  return /* @__PURE__ */ x(
    Zs,
    _(_({
      ref: e
    }, r.getStyles("title", { classNames: s, style: l, styles: i, className: n })), u)
  );
});
Ze.classes = pe;
Ze.displayName = "@mantine/core/ModalTitle";
const ca = {
  closeOnClickOutside: !0,
  withinPortal: !0,
  lockScroll: !0,
  trapFocus: !0,
  returnFocus: !0,
  closeOnEscape: !0,
  keepMounted: !1,
  zIndex: Ie("modal"),
  transitionProps: { duration: 200, transition: "fade-down" },
  withOverlay: !0,
  withCloseButton: !0
}, ue = K((t, e) => {
  const k = J("Modal", ca, t), {
    title: a,
    withOverlay: s,
    overlayProps: n,
    withCloseButton: l,
    closeButtonProps: i,
    children: c,
    radius: u,
    opened: r,
    stackId: o,
    zIndex: D
  } = k, v = j(k, [
    "title",
    "withOverlay",
    "overlayProps",
    "withCloseButton",
    "closeButtonProps",
    "children",
    "radius",
    "opened",
    "stackId",
    "zIndex"
  ]), h = ia(), d = !!a || l, m = h && o ? {
    closeOnEscape: h.currentId === o,
    trapFocus: h.currentId === o,
    zIndex: h.getZIndex(o)
  } : {}, b = s === !1 ? !1 : o && h ? h.currentId === o : r;
  return Vt(() => {
    h && o && (r ? h.addModal(o, D || Ie("modal")) : h.removeModal(o));
  }, [r, o, D]), /* @__PURE__ */ ie(
    je,
    I(_(_({
      ref: e,
      radius: u,
      opened: r,
      zIndex: h && o ? h.getZIndex(o) : D
    }, v), m), {
      children: [
        s && /* @__PURE__ */ x(
          Ge,
          _({
            visible: b,
            transitionProps: h && o ? { duration: 0 } : void 0
          }, n)
        ),
        /* @__PURE__ */ ie(
          Ve,
          {
            radius: u,
            __hidden: h && o && r ? o !== h.currentId : !1,
            children: [
              d && /* @__PURE__ */ ie(Ue, { children: [
                a && /* @__PURE__ */ x(Ze, { children: a }),
                l && /* @__PURE__ */ x(Ee, _({}, i))
              ] }),
              /* @__PURE__ */ x(Be, { children: c })
            ]
          }
        )
      ]
    })
  );
});
ue.classes = pe;
ue.displayName = "@mantine/core/Modal";
ue.Root = je;
ue.Overlay = Ge;
ue.Content = Ve;
ue.Body = Be;
ue.Header = Ue;
ue.Title = Ze;
ue.CloseButton = Ee;
ue.Stack = Gt;
var Te = { exports: {} }, ua = Te.exports, Wt;
function da() {
  return Wt || (Wt = 1, function(t, e) {
    (function(a, s) {
      t.exports = s();
    })(ua, function() {
      var a = 1e3, s = 6e4, n = 36e5, l = "millisecond", i = "second", c = "minute", u = "hour", r = "day", o = "week", D = "month", v = "quarter", h = "year", d = "date", m = "Invalid Date", b = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, k = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, N = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(M) {
        var g = ["th", "st", "nd", "rd"], y = M % 100;
        return "[" + M + (g[(y - 20) % 10] || g[y] || g[0]) + "]";
      } }, C = function(M, g, y) {
        var w = String(M);
        return !w || w.length >= g ? M : "" + Array(g + 1 - w.length).join(y) + M;
      }, R = { s: C, z: function(M) {
        var g = -M.utcOffset(), y = Math.abs(g), w = Math.floor(y / 60), p = y % 60;
        return (g <= 0 ? "+" : "-") + C(w, 2, "0") + ":" + C(p, 2, "0");
      }, m: function M(g, y) {
        if (g.date() < y.date()) return -M(y, g);
        var w = 12 * (y.year() - g.year()) + (y.month() - g.month()), p = g.clone().add(w, D), L = y - p < 0, f = g.clone().add(w + (L ? -1 : 1), D);
        return +(-(w + (y - p) / (L ? p - f : f - p)) || 0);
      }, a: function(M) {
        return M < 0 ? Math.ceil(M) || 0 : Math.floor(M);
      }, p: function(M) {
        return { M: D, y: h, w: o, d: r, D: d, h: u, m: c, s: i, ms: l, Q: v }[M] || String(M || "").toLowerCase().replace(/s$/, "");
      }, u: function(M) {
        return M === void 0;
      } }, F = "en", S = {};
      S[F] = N;
      var A = "$isDayjsObject", W = function(M) {
        return M instanceof B || !(!M || !M[A]);
      }, P = function M(g, y, w) {
        var p;
        if (!g) return F;
        if (typeof g == "string") {
          var L = g.toLowerCase();
          S[L] && (p = L), y && (S[L] = y, p = L);
          var f = g.split("-");
          if (!p && f.length > 1) return M(f[0]);
        } else {
          var H = g.name;
          S[H] = g, p = H;
        }
        return !w && p && (F = p), p || !w && F;
      }, z = function(M, g) {
        if (W(M)) return M.clone();
        var y = typeof g == "object" ? g : {};
        return y.date = M, y.args = arguments, new B(y);
      }, T = R;
      T.l = P, T.i = W, T.w = function(M, g) {
        return z(M, { locale: g.$L, utc: g.$u, x: g.$x, $offset: g.$offset });
      };
      var B = function() {
        function M(y) {
          this.$L = P(y.locale, null, !0), this.parse(y), this.$x = this.$x || y.x || {}, this[A] = !0;
        }
        var g = M.prototype;
        return g.parse = function(y) {
          this.$d = function(w) {
            var p = w.date, L = w.utc;
            if (p === null) return /* @__PURE__ */ new Date(NaN);
            if (T.u(p)) return /* @__PURE__ */ new Date();
            if (p instanceof Date) return new Date(p);
            if (typeof p == "string" && !/Z$/i.test(p)) {
              var f = p.match(b);
              if (f) {
                var H = f[2] - 1 || 0, $ = (f[7] || "0").substring(0, 3);
                return L ? new Date(Date.UTC(f[1], H, f[3] || 1, f[4] || 0, f[5] || 0, f[6] || 0, $)) : new Date(f[1], H, f[3] || 1, f[4] || 0, f[5] || 0, f[6] || 0, $);
              }
            }
            return new Date(p);
          }(y), this.init();
        }, g.init = function() {
          var y = this.$d;
          this.$y = y.getFullYear(), this.$M = y.getMonth(), this.$D = y.getDate(), this.$W = y.getDay(), this.$H = y.getHours(), this.$m = y.getMinutes(), this.$s = y.getSeconds(), this.$ms = y.getMilliseconds();
        }, g.$utils = function() {
          return T;
        }, g.isValid = function() {
          return this.$d.toString() !== m;
        }, g.isSame = function(y, w) {
          var p = z(y);
          return this.startOf(w) <= p && p <= this.endOf(w);
        }, g.isAfter = function(y, w) {
          return z(y) < this.startOf(w);
        }, g.isBefore = function(y, w) {
          return this.endOf(w) < z(y);
        }, g.$g = function(y, w, p) {
          return T.u(y) ? this[w] : this.set(p, y);
        }, g.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, g.valueOf = function() {
          return this.$d.getTime();
        }, g.startOf = function(y, w) {
          var p = this, L = !!T.u(w) || w, f = T.p(y), H = function(re, U) {
            var se = T.w(p.$u ? Date.UTC(p.$y, U, re) : new Date(p.$y, U, re), p);
            return L ? se : se.endOf(r);
          }, $ = function(re, U) {
            return T.w(p.toDate()[re].apply(p.toDate("s"), (L ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(U)), p);
          }, Y = this.$W, V = this.$M, Z = this.$D, ee = "set" + (this.$u ? "UTC" : "");
          switch (f) {
            case h:
              return L ? H(1, 0) : H(31, 11);
            case D:
              return L ? H(1, V) : H(0, V + 1);
            case o:
              var X = this.$locale().weekStart || 0, Q = (Y < X ? Y + 7 : Y) - X;
              return H(L ? Z - Q : Z + (6 - Q), V);
            case r:
            case d:
              return $(ee + "Hours", 0);
            case u:
              return $(ee + "Minutes", 1);
            case c:
              return $(ee + "Seconds", 2);
            case i:
              return $(ee + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, g.endOf = function(y) {
          return this.startOf(y, !1);
        }, g.$set = function(y, w) {
          var p, L = T.p(y), f = "set" + (this.$u ? "UTC" : ""), H = (p = {}, p[r] = f + "Date", p[d] = f + "Date", p[D] = f + "Month", p[h] = f + "FullYear", p[u] = f + "Hours", p[c] = f + "Minutes", p[i] = f + "Seconds", p[l] = f + "Milliseconds", p)[L], $ = L === r ? this.$D + (w - this.$W) : w;
          if (L === D || L === h) {
            var Y = this.clone().set(d, 1);
            Y.$d[H]($), Y.init(), this.$d = Y.set(d, Math.min(this.$D, Y.daysInMonth())).$d;
          } else H && this.$d[H]($);
          return this.init(), this;
        }, g.set = function(y, w) {
          return this.clone().$set(y, w);
        }, g.get = function(y) {
          return this[T.p(y)]();
        }, g.add = function(y, w) {
          var p, L = this;
          y = Number(y);
          var f = T.p(w), H = function(V) {
            var Z = z(L);
            return T.w(Z.date(Z.date() + Math.round(V * y)), L);
          };
          if (f === D) return this.set(D, this.$M + y);
          if (f === h) return this.set(h, this.$y + y);
          if (f === r) return H(1);
          if (f === o) return H(7);
          var $ = (p = {}, p[c] = s, p[u] = n, p[i] = a, p)[f] || 1, Y = this.$d.getTime() + y * $;
          return T.w(Y, this);
        }, g.subtract = function(y, w) {
          return this.add(-1 * y, w);
        }, g.format = function(y) {
          var w = this, p = this.$locale();
          if (!this.isValid()) return p.invalidDate || m;
          var L = y || "YYYY-MM-DDTHH:mm:ssZ", f = T.z(this), H = this.$H, $ = this.$m, Y = this.$M, V = p.weekdays, Z = p.months, ee = p.meridiem, X = function(U, se, q, te) {
            return U && (U[se] || U(w, L)) || q[se].slice(0, te);
          }, Q = function(U) {
            return T.s(H % 12 || 12, U, "0");
          }, re = ee || function(U, se, q) {
            var te = U < 12 ? "AM" : "PM";
            return q ? te.toLowerCase() : te;
          };
          return L.replace(k, function(U, se) {
            return se || function(q) {
              switch (q) {
                case "YY":
                  return String(w.$y).slice(-2);
                case "YYYY":
                  return T.s(w.$y, 4, "0");
                case "M":
                  return Y + 1;
                case "MM":
                  return T.s(Y + 1, 2, "0");
                case "MMM":
                  return X(p.monthsShort, Y, Z, 3);
                case "MMMM":
                  return X(Z, Y);
                case "D":
                  return w.$D;
                case "DD":
                  return T.s(w.$D, 2, "0");
                case "d":
                  return String(w.$W);
                case "dd":
                  return X(p.weekdaysMin, w.$W, V, 2);
                case "ddd":
                  return X(p.weekdaysShort, w.$W, V, 3);
                case "dddd":
                  return V[w.$W];
                case "H":
                  return String(H);
                case "HH":
                  return T.s(H, 2, "0");
                case "h":
                  return Q(1);
                case "hh":
                  return Q(2);
                case "a":
                  return re(H, $, !0);
                case "A":
                  return re(H, $, !1);
                case "m":
                  return String($);
                case "mm":
                  return T.s($, 2, "0");
                case "s":
                  return String(w.$s);
                case "ss":
                  return T.s(w.$s, 2, "0");
                case "SSS":
                  return T.s(w.$ms, 3, "0");
                case "Z":
                  return f;
              }
              return null;
            }(U) || f.replace(":", "");
          });
        }, g.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, g.diff = function(y, w, p) {
          var L, f = this, H = T.p(w), $ = z(y), Y = ($.utcOffset() - this.utcOffset()) * s, V = this - $, Z = function() {
            return T.m(f, $);
          };
          switch (H) {
            case h:
              L = Z() / 12;
              break;
            case D:
              L = Z();
              break;
            case v:
              L = Z() / 3;
              break;
            case o:
              L = (V - Y) / 6048e5;
              break;
            case r:
              L = (V - Y) / 864e5;
              break;
            case u:
              L = V / n;
              break;
            case c:
              L = V / s;
              break;
            case i:
              L = V / a;
              break;
            default:
              L = V;
          }
          return p ? L : T.a(L);
        }, g.daysInMonth = function() {
          return this.endOf(D).$D;
        }, g.$locale = function() {
          return S[this.$L];
        }, g.locale = function(y, w) {
          if (!y) return this.$L;
          var p = this.clone(), L = P(y, w, !0);
          return L && (p.$L = L), p;
        }, g.clone = function() {
          return T.w(this.$d, this);
        }, g.toDate = function() {
          return new Date(this.valueOf());
        }, g.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, g.toISOString = function() {
          return this.$d.toISOString();
        }, g.toString = function() {
          return this.$d.toUTCString();
        }, M;
      }(), E = B.prototype;
      return z.prototype = E, [["$ms", l], ["$s", i], ["$m", c], ["$H", u], ["$W", r], ["$M", D], ["$y", h], ["$D", d]].forEach(function(M) {
        E[M[1]] = function(g) {
          return this.$g(g, M[0], M[1]);
        };
      }), z.extend = function(M, g) {
        return M.$i || (M(g, B, z), M.$i = !0), z;
      }, z.locale = P, z.isDayjs = W, z.unix = function(M) {
        return z(1e3 * M);
      }, z.en = S[F], z.Ls = S, z.p = {}, z;
    });
  }(Te)), Te.exports;
}
var fa = da();
const O = /* @__PURE__ */ Pe(fa);
function ma({
  type: t,
  date: e,
  locale: a,
  format: s,
  labelSeparator: n
}) {
  const l = (i) => O(i).locale(a).format(s);
  return t === "default" ? e === null ? "" : l(e) : t === "multiple" ? e.map(l).join(", ") : t === "range" && Array.isArray(e) ? e[0] && e[1] ? `${l(e[0])} ${n} ${l(e[1])}` : e[0] ? `${l(e[0])} ${n} ` : "" : "";
}
function ha(a) {
  var s = a, { formatter: t } = s, e = j(s, ["formatter"]);
  return (t || ma)(e);
}
function pa({ direction: t, levelIndex: e, rowIndex: a, cellIndex: s, size: n }) {
  switch (t) {
    case "up":
      return e === 0 && a === 0 ? null : a === 0 ? {
        levelIndex: e - 1,
        rowIndex: s <= n[e - 1][n[e - 1].length - 1] - 1 ? n[e - 1].length - 1 : n[e - 1].length - 2,
        cellIndex: s
      } : {
        levelIndex: e,
        rowIndex: a - 1,
        cellIndex: s
      };
    case "down":
      return a === n[e].length - 1 ? {
        levelIndex: e + 1,
        rowIndex: 0,
        cellIndex: s
      } : a === n[e].length - 2 && s >= n[e][n[e].length - 1] ? {
        levelIndex: e + 1,
        rowIndex: 0,
        cellIndex: s
      } : {
        levelIndex: e,
        rowIndex: a + 1,
        cellIndex: s
      };
    case "left":
      return e === 0 && a === 0 && s === 0 ? null : a === 0 && s === 0 ? {
        levelIndex: e - 1,
        rowIndex: n[e - 1].length - 1,
        cellIndex: n[e - 1][n[e - 1].length - 1] - 1
      } : s === 0 ? {
        levelIndex: e,
        rowIndex: a - 1,
        cellIndex: n[e][a - 1] - 1
      } : {
        levelIndex: e,
        rowIndex: a,
        cellIndex: s - 1
      };
    case "right":
      return a === n[e].length - 1 && s === n[e][a] - 1 ? {
        levelIndex: e + 1,
        rowIndex: 0,
        cellIndex: 0
      } : s === n[e][a] - 1 ? {
        levelIndex: e,
        rowIndex: a + 1,
        cellIndex: 0
      } : {
        levelIndex: e,
        rowIndex: a,
        cellIndex: s + 1
      };
    default:
      return { levelIndex: e, rowIndex: a, cellIndex: s };
  }
}
function jt({
  controlsRef: t,
  direction: e,
  levelIndex: a,
  rowIndex: s,
  cellIndex: n,
  size: l
}) {
  var u, r, o;
  const i = pa({ direction: e, size: l, rowIndex: s, cellIndex: n, levelIndex: a });
  if (!i)
    return;
  const c = (o = (r = (u = t.current) == null ? void 0 : u[i.levelIndex]) == null ? void 0 : r[i.rowIndex]) == null ? void 0 : o[i.cellIndex];
  c && (c.disabled || c.getAttribute("data-hidden") || c.getAttribute("data-outside") ? jt({
    controlsRef: t,
    direction: e,
    levelIndex: i.levelIndex,
    cellIndex: i.cellIndex,
    rowIndex: i.rowIndex,
    size: l
  }) : c.focus());
}
function ya(t) {
  switch (t) {
    case "ArrowDown":
      return "down";
    case "ArrowUp":
      return "up";
    case "ArrowRight":
      return "right";
    case "ArrowLeft":
      return "left";
    default:
      return null;
  }
}
function va(t) {
  var e;
  return (e = t.current) == null ? void 0 : e.map((a) => a.map((s) => s.length));
}
function bt({
  controlsRef: t,
  levelIndex: e,
  rowIndex: a,
  cellIndex: s,
  event: n
}) {
  const l = ya(n.key);
  if (l) {
    n.preventDefault();
    const i = va(t);
    jt({
      controlsRef: t,
      direction: l,
      levelIndex: e,
      rowIndex: a,
      cellIndex: s,
      size: i
    });
  }
}
var Ae = { exports: {} }, Da = Ae.exports, Pt;
function _a() {
  return Pt || (Pt = 1, function(t, e) {
    (function(a, s) {
      t.exports = s();
    })(Da, function() {
      var a = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, s = {};
      return function(n, l, i) {
        var c, u = function(v, h, d) {
          d === void 0 && (d = {});
          var m = new Date(v), b = function(k, N) {
            N === void 0 && (N = {});
            var C = N.timeZoneName || "short", R = k + "|" + C, F = s[R];
            return F || (F = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: k, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: C }), s[R] = F), F;
          }(h, d);
          return b.formatToParts(m);
        }, r = function(v, h) {
          for (var d = u(v, h), m = [], b = 0; b < d.length; b += 1) {
            var k = d[b], N = k.type, C = k.value, R = a[N];
            R >= 0 && (m[R] = parseInt(C, 10));
          }
          var F = m[3], S = F === 24 ? 0 : F, A = m[0] + "-" + m[1] + "-" + m[2] + " " + S + ":" + m[4] + ":" + m[5] + ":000", W = +v;
          return (i.utc(A).valueOf() - (W -= W % 1e3)) / 6e4;
        }, o = l.prototype;
        o.tz = function(v, h) {
          v === void 0 && (v = c);
          var d, m = this.utcOffset(), b = this.toDate(), k = b.toLocaleString("en-US", { timeZone: v }), N = Math.round((b - new Date(k)) / 1e3 / 60), C = 15 * -Math.round(b.getTimezoneOffset() / 15) - N;
          if (!Number(C)) d = this.utcOffset(0, h);
          else if (d = i(k, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(C, !0), h) {
            var R = d.utcOffset();
            d = d.add(m - R, "minute");
          }
          return d.$x.$timezone = v, d;
        }, o.offsetName = function(v) {
          var h = this.$x.$timezone || i.tz.guess(), d = u(this.valueOf(), h, { timeZoneName: v }).find(function(m) {
            return m.type.toLowerCase() === "timezonename";
          });
          return d && d.value;
        };
        var D = o.startOf;
        o.startOf = function(v, h) {
          if (!this.$x || !this.$x.$timezone) return D.call(this, v, h);
          var d = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return D.call(d, v, h).tz(this.$x.$timezone, !0);
        }, i.tz = function(v, h, d) {
          var m = d && h, b = d || h || c, k = r(+i(), b);
          if (typeof v != "string") return i(v).tz(b);
          var N = function(S, A, W) {
            var P = S - 60 * A * 1e3, z = r(P, W);
            if (A === z) return [P, A];
            var T = r(P -= 60 * (z - A) * 1e3, W);
            return z === T ? [P, z] : [S - 60 * Math.min(z, T) * 1e3, Math.max(z, T)];
          }(i.utc(v, m).valueOf(), k, b), C = N[0], R = N[1], F = i(C).utcOffset(R);
          return F.$x.$timezone = b, F;
        }, i.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, i.tz.setDefault = function(v) {
          c = v;
        };
      };
    });
  }(Ae)), Ae.exports;
}
var ga = _a();
const ba = /* @__PURE__ */ Pe(ga);
var Ye = { exports: {} }, Sa = Ye.exports, Rt;
function $a() {
  return Rt || (Rt = 1, function(t, e) {
    (function(a, s) {
      t.exports = s();
    })(Sa, function() {
      var a = "minute", s = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
      return function(l, i, c) {
        var u = i.prototype;
        c.utc = function(m) {
          var b = { date: m, utc: !0, args: arguments };
          return new i(b);
        }, u.utc = function(m) {
          var b = c(this.toDate(), { locale: this.$L, utc: !0 });
          return m ? b.add(this.utcOffset(), a) : b;
        }, u.local = function() {
          return c(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var r = u.parse;
        u.parse = function(m) {
          m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), r.call(this, m);
        };
        var o = u.init;
        u.init = function() {
          if (this.$u) {
            var m = this.$d;
            this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
          } else o.call(this);
        };
        var D = u.utcOffset;
        u.utcOffset = function(m, b) {
          var k = this.$utils().u;
          if (k(m)) return this.$u ? 0 : k(this.$offset) ? D.call(this) : this.$offset;
          if (typeof m == "string" && (m = function(F) {
            F === void 0 && (F = "");
            var S = F.match(s);
            if (!S) return null;
            var A = ("" + S[0]).match(n) || ["-", 0, 0], W = A[0], P = 60 * +A[1] + +A[2];
            return P === 0 ? 0 : W === "+" ? P : -P;
          }(m), m === null)) return this;
          var N = Math.abs(m) <= 16 ? 60 * m : m, C = this;
          if (b) return C.$offset = N, C.$u = m === 0, C;
          if (m !== 0) {
            var R = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (C = this.local().add(N + R, a)).$offset = N, C.$x.$localOffset = R;
          } else C = this.utc();
          return C;
        };
        var v = u.format;
        u.format = function(m) {
          var b = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return v.call(this, b);
        }, u.valueOf = function() {
          var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * m;
        }, u.isUTC = function() {
          return !!this.$u;
        }, u.toISOString = function() {
          return this.toDate().toISOString();
        }, u.toString = function() {
          return this.toDate().toUTCString();
        };
        var h = u.toDate;
        u.toDate = function(m) {
          return m === "s" && this.$offset ? c(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
        };
        var d = u.diff;
        u.diff = function(m, b, k) {
          if (m && this.$u === m.$u) return d.call(this, m, b, k);
          var N = this.local(), C = c(m).local();
          return d.call(N, C, b, k);
        };
      };
    });
  }(Ye)), Ye.exports;
}
var wa = $a();
const Ma = /* @__PURE__ */ Pe(wa);
O.extend(Ma);
O.extend(ba);
function ka(t, e) {
  return e ? O(t).tz(e).utcOffset() + t.getTimezoneOffset() : 0;
}
const Ht = (t, e, a) => {
  if (!t)
    return null;
  if (!e)
    return t;
  let s = ka(t, e);
  return a === "remove" && (s *= -1), O(t).add(s, "minutes").toDate();
};
function me(t, e, a, s) {
  return s || !e ? e : Array.isArray(e) ? e.map((n) => Ht(n, a, t)) : Ht(e, a, t);
}
function Ca({ minDate: t, maxDate: e, timezone: a }) {
  const s = me("add", /* @__PURE__ */ new Date(), a);
  return !t && !e ? s : t && O(s).isBefore(t) ? t : e && O(s).isAfter(e) ? e : s;
}
const La = {
  locale: "en",
  timezone: null,
  firstDayOfWeek: 1,
  weekendDays: [0, 6],
  labelSeparator: "–",
  consistentWeeks: !1
}, Oa = Ls(La);
function le() {
  const t = Os(Oa), e = $e((i) => i || t.locale, [t.locale]), a = $e(
    (i) => i || t.timezone || void 0,
    [t.timezone]
  ), s = $e(
    (i) => typeof i == "number" ? i : t.firstDayOfWeek,
    [t.firstDayOfWeek]
  ), n = $e(
    (i) => Array.isArray(i) ? i : t.weekendDays,
    [t.weekendDays]
  ), l = $e(
    (i) => typeof i == "string" ? i : t.labelSeparator,
    [t.labelSeparator]
  );
  return I(_({}, t), {
    getLocale: e,
    getTimezone: a,
    getFirstDayOfWeek: s,
    getWeekendDays: n,
    getLabelSeparator: l
  });
}
function xa(t, e) {
  const a = le(), s = (n) => me("remove", n, a.getTimezone()).toISOString();
  if (e === "range" && Array.isArray(t)) {
    const [n, l] = t;
    return n ? l ? `${s(n)} – ${s(l)}` : `${s(n)} –` : "";
  }
  return e === "multiple" && Array.isArray(t) ? t.map((n) => n && s(n)).filter(Boolean).join(", ") : !Array.isArray(t) && t ? s(t) : "";
}
function Zt({ value: t, type: e, name: a, form: s }) {
  return /* @__PURE__ */ x("input", { type: "hidden", value: xa(t, e), name: a, form: s });
}
Zt.displayName = "@mantine/dates/HiddenDatesInput";
var Kt = { day: "m_396ce5cb" };
const Na = {}, Ta = ge((t, { size: e }) => ({
  day: {
    "--day-size": Ce(e, "day-size")
  }
})), St = K((t, e) => {
  const a = J("Day", Na, t), P = a, {
    classNames: s,
    className: n,
    style: l,
    styles: i,
    unstyled: c,
    vars: u,
    date: r,
    disabled: o,
    __staticSelector: D,
    weekend: v,
    outside: h,
    selected: d,
    renderDay: m,
    inRange: b,
    firstInRange: k,
    lastInRange: N,
    hidden: C,
    static: R,
    highlightToday: F
  } = P, S = j(P, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "date",
    "disabled",
    "__staticSelector",
    "weekend",
    "outside",
    "selected",
    "renderDay",
    "inRange",
    "firstInRange",
    "lastInRange",
    "hidden",
    "static",
    "highlightToday"
  ]), A = he({
    name: D || "Day",
    classes: Kt,
    props: a,
    className: n,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: u,
    varsResolver: Ta,
    rootSelector: "day"
  }), W = le();
  return /* @__PURE__ */ x(
    Me,
    I(_(I(_({}, A("day", { style: C ? { display: "none" } : void 0 })), {
      component: R ? "div" : "button",
      ref: e,
      disabled: o,
      "data-today": O(r).isSame(me("add", /* @__PURE__ */ new Date(), W.getTimezone()), "day") || void 0,
      "data-hidden": C || void 0,
      "data-highlight-today": F || void 0,
      "data-disabled": o || void 0,
      "data-weekend": !o && !h && v || void 0,
      "data-outside": !o && h || void 0,
      "data-selected": !o && d || void 0,
      "data-in-range": b && !o || void 0,
      "data-first-in-range": k && !o || void 0,
      "data-last-in-range": N && !o || void 0,
      "data-static": R || void 0,
      unstyled: c
    }), S), {
      children: (m == null ? void 0 : m(r)) || O(r).date()
    })
  );
});
St.classes = Kt;
St.displayName = "@mantine/dates/Day";
function Aa({
  locale: t,
  format: e = "dd",
  firstDayOfWeek: a = 1
}) {
  const s = O().day(a), n = [];
  for (let l = 0; l < 7; l += 1)
    typeof e == "string" ? n.push(O(s).add(l, "days").locale(t).format(e)) : n.push(e(O(s).add(l, "days").toDate()));
  return n;
}
var qt = { weekday: "m_18a3eca" };
const Ya = {}, Fa = ge((t, { size: e }) => ({
  weekdaysRow: {
    "--wr-fz": Re(e),
    "--wr-spacing": Ps(e)
  }
})), $t = K((t, e) => {
  const a = J("WeekdaysRow", Ya, t), C = a, {
    classNames: s,
    className: n,
    style: l,
    styles: i,
    unstyled: c,
    vars: u,
    locale: r,
    firstDayOfWeek: o,
    weekdayFormat: D,
    cellComponent: v = "th",
    __staticSelector: h,
    withWeekNumbers: d
  } = C, m = j(C, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "locale",
    "firstDayOfWeek",
    "weekdayFormat",
    "cellComponent",
    "__staticSelector",
    "withWeekNumbers"
  ]), b = he({
    name: h || "WeekdaysRow",
    classes: qt,
    props: a,
    className: n,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: u,
    varsResolver: Fa,
    rootSelector: "weekdaysRow"
  }), k = le(), N = Aa({
    locale: k.getLocale(r),
    format: D,
    firstDayOfWeek: k.getFirstDayOfWeek(o)
  }).map((R, F) => /* @__PURE__ */ x(v, I(_({}, b("weekday")), { children: R }), F));
  return /* @__PURE__ */ ie(de, I(_(_({ component: "tr", ref: e }, b("weekdaysRow")), m), { children: [
    d && /* @__PURE__ */ x(v, I(_({}, b("weekday")), { children: "#" })),
    N
  ] }));
});
$t.classes = qt;
$t.displayName = "@mantine/dates/WeekdaysRow";
function za(t, e = 1) {
  let a = O(t);
  const s = e === 0 ? 6 : e - 1;
  for (; a.day() !== s; )
    a = a.add(1, "day");
  return a.toDate();
}
function Wa(t, e = 1) {
  let a = O(t);
  for (; a.day() !== e; )
    a = a.subtract(1, "day");
  return a.toDate();
}
function Pa({
  month: t,
  firstDayOfWeek: e = 1,
  consistentWeeks: a
}) {
  const s = O(t).subtract(O(t).date() - 1, "day"), n = O(s).startOf("day"), l = n.toDate(), i = n.add(+n.daysInMonth() - 1, "day").toDate(), c = za(i, e), u = Wa(l, e), r = [];
  for (; u <= c; ) {
    const o = [];
    for (let D = 0; D < 7; D += 1)
      o.push(new Date(u)), u.setDate(u.getDate() + 1);
    r.push(o);
  }
  if (a && r.length < 6) {
    const o = r[r.length - 1], D = o[o.length - 1], v = new Date(D);
    for (v.setDate(v.getDate() + 1); r.length < 6; ) {
      const h = [];
      for (let d = 0; d < 7; d += 1)
        h.push(new Date(v)), v.setDate(v.getDate() + 1);
      r.push(h);
    }
  }
  return r;
}
function Jt(t, e) {
  return O(t).format("YYYY-MM") === O(e).format("YYYY-MM");
}
function Qt(t, e) {
  return e instanceof Date ? O(t).isAfter(O(e).subtract(1, "day"), "day") : !0;
}
function Xt(t, e) {
  return e instanceof Date ? O(t).isBefore(O(e).add(1, "day"), "day") : !0;
}
function Ra(t, e, a, s, n, l, i) {
  const c = t.flat().filter(
    (o) => {
      var D;
      return Xt(o, a) && Qt(o, e) && !(n != null && n(o)) && !((D = s == null ? void 0 : s(o)) != null && D.disabled) && (!l || Jt(o, i));
    }
  ), u = c.find((o) => {
    var D;
    return (D = s == null ? void 0 : s(o)) == null ? void 0 : D.selected;
  });
  if (u)
    return u;
  const r = c.find((o) => O().isSame(o, "date"));
  return r || c[0];
}
var Fe = { exports: {} }, Ha = Fe.exports, It;
function Ia() {
  return It || (It = 1, function(t, e) {
    (function(a, s) {
      t.exports = s();
    })(Ha, function() {
      var a = "day";
      return function(s, n, l) {
        var i = function(r) {
          return r.add(4 - r.isoWeekday(), a);
        }, c = n.prototype;
        c.isoWeekYear = function() {
          return i(this).year();
        }, c.isoWeek = function(r) {
          if (!this.$utils().u(r)) return this.add(7 * (r - this.isoWeek()), a);
          var o, D, v, h, d = i(this), m = (o = this.isoWeekYear(), D = this.$u, v = (D ? l.utc : l)().year(o).startOf("year"), h = 4 - v.isoWeekday(), v.isoWeekday() > 4 && (h += 7), v.add(h, a));
          return d.diff(m, "week") + 1;
        }, c.isoWeekday = function(r) {
          return this.$utils().u(r) ? this.day() || 7 : this.day(this.day() % 7 ? r : r - 7);
        };
        var u = c.startOf;
        c.startOf = function(r, o) {
          var D = this.$utils(), v = !!D.u(o) || o;
          return D.p(r) === "isoweek" ? v ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : u.bind(this)(r, o);
        };
      };
    });
  }(Fe)), Fe.exports;
}
var Ba = Ia();
const Ea = /* @__PURE__ */ Pe(Ba);
O.extend(Ea);
function Va(t) {
  const e = t.find((a) => O(a).day() === 1);
  return O(e).isoWeek();
}
var es = { month: "m_cc9820d3", monthCell: "m_8f457cd5", weekNumber: "m_6cff9dea" };
const Ua = {
  withCellSpacing: !0
}, Ga = ge((t, { size: e }) => ({
  weekNumber: {
    "--wn-fz": Re(e),
    "--wn-size": Ce(e, "wn-size")
  }
})), Ke = K((t, e) => {
  const a = J("Month", Ua, t), ee = a, {
    classNames: s,
    className: n,
    style: l,
    styles: i,
    unstyled: c,
    vars: u,
    __staticSelector: r,
    locale: o,
    firstDayOfWeek: D,
    weekdayFormat: v,
    month: h,
    weekendDays: d,
    getDayProps: m,
    excludeDate: b,
    minDate: k,
    maxDate: N,
    renderDay: C,
    hideOutsideDates: R,
    hideWeekdays: F,
    getDayAriaLabel: S,
    static: A,
    __getDayRef: W,
    __onDayKeyDown: P,
    __onDayClick: z,
    __onDayMouseEnter: T,
    __preventFocus: B,
    __stopPropagation: E,
    withCellSpacing: M,
    size: g,
    highlightToday: y,
    withWeekNumbers: w
  } = ee, p = j(ee, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "__staticSelector",
    "locale",
    "firstDayOfWeek",
    "weekdayFormat",
    "month",
    "weekendDays",
    "getDayProps",
    "excludeDate",
    "minDate",
    "maxDate",
    "renderDay",
    "hideOutsideDates",
    "hideWeekdays",
    "getDayAriaLabel",
    "static",
    "__getDayRef",
    "__onDayKeyDown",
    "__onDayClick",
    "__onDayMouseEnter",
    "__preventFocus",
    "__stopPropagation",
    "withCellSpacing",
    "size",
    "highlightToday",
    "withWeekNumbers"
  ]), L = he({
    name: r || "Month",
    classes: es,
    props: a,
    className: n,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: u,
    varsResolver: Ga,
    rootSelector: "month"
  }), f = le(), H = Pa({
    month: h,
    firstDayOfWeek: f.getFirstDayOfWeek(D),
    consistentWeeks: f.consistentWeeks
  }), $ = Ra(
    H,
    k,
    N,
    m,
    b,
    R,
    h
  ), { resolvedClassNames: Y, resolvedStyles: V } = He({
    classNames: s,
    styles: i,
    props: a
  }), Z = H.map((X, Q) => {
    const re = X.map((U, se) => {
      const q = !Jt(U, h), te = (S == null ? void 0 : S(U)) || O(U).locale(o || f.locale).format("D MMMM YYYY"), G = m == null ? void 0 : m(U), ce = O(U).isSame($, "date");
      return /* @__PURE__ */ x(
        "td",
        I(_({}, L("monthCell")), {
          "data-with-spacing": M || void 0,
          children: /* @__PURE__ */ x(
            St,
            I(_({
              __staticSelector: r || "Month",
              classNames: Y,
              styles: V,
              unstyled: c,
              "data-mantine-stop-propagation": E || void 0,
              highlightToday: y,
              renderDay: C,
              date: U,
              size: g,
              weekend: f.getWeekendDays(d).includes(U.getDay()),
              outside: q,
              hidden: R ? q : !1,
              "aria-label": te,
              static: A,
              disabled: (b == null ? void 0 : b(U)) || !Xt(U, N) || !Qt(U, k),
              ref: (ae) => W == null ? void 0 : W(Q, se, ae)
            }, G), {
              onKeyDown: (ae) => {
                var oe;
                (oe = G == null ? void 0 : G.onKeyDown) == null || oe.call(G, ae), P == null || P(ae, { rowIndex: Q, cellIndex: se, date: U });
              },
              onMouseEnter: (ae) => {
                var oe;
                (oe = G == null ? void 0 : G.onMouseEnter) == null || oe.call(G, ae), T == null || T(ae, U);
              },
              onClick: (ae) => {
                var oe;
                (oe = G == null ? void 0 : G.onClick) == null || oe.call(G, ae), z == null || z(ae, U);
              },
              onMouseDown: (ae) => {
                var oe;
                (oe = G == null ? void 0 : G.onMouseDown) == null || oe.call(G, ae), B && ae.preventDefault();
              },
              tabIndex: B || !ce ? -1 : 0
            })
          )
        }),
        U.toString()
      );
    });
    return /* @__PURE__ */ ie("tr", I(_({}, L("monthRow")), { children: [
      w && /* @__PURE__ */ x("td", I(_({}, L("weekNumber")), { children: Va(X) })),
      re
    ] }), Q);
  });
  return /* @__PURE__ */ ie(de, I(_(I(_({ component: "table" }, L("month")), { size: g, ref: e }), p), { children: [
    !F && /* @__PURE__ */ x("thead", I(_({}, L("monthThead")), { children: /* @__PURE__ */ x(
      $t,
      {
        __staticSelector: r || "Month",
        locale: o,
        firstDayOfWeek: D,
        weekdayFormat: v,
        size: g,
        classNames: Y,
        styles: V,
        unstyled: c,
        withWeekNumbers: w
      }
    ) })),
    /* @__PURE__ */ x("tbody", I(_({}, L("monthTbody")), { children: Z }))
  ] }));
});
Ke.classes = es;
Ke.displayName = "@mantine/dates/Month";
var ts = { pickerControl: "m_dc6a3c71" };
const ja = {}, Za = ge((t, { size: e }) => ({
  pickerControl: {
    "--dpc-fz": Re(e),
    "--dpc-size": Ce(e, "dpc-size")
  }
})), qe = K((t, e) => {
  const a = J("PickerControl", ja, t), k = a, {
    classNames: s,
    className: n,
    style: l,
    styles: i,
    unstyled: c,
    vars: u,
    firstInRange: r,
    lastInRange: o,
    inRange: D,
    __staticSelector: v,
    selected: h,
    disabled: d
  } = k, m = j(k, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "firstInRange",
    "lastInRange",
    "inRange",
    "__staticSelector",
    "selected",
    "disabled"
  ]), b = he({
    name: v || "PickerControl",
    classes: ts,
    props: a,
    className: n,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: u,
    varsResolver: Za,
    rootSelector: "pickerControl"
  });
  return /* @__PURE__ */ x(
    Me,
    _(I(_({}, b("pickerControl")), {
      ref: e,
      unstyled: c,
      "data-picker-control": !0,
      "data-selected": h && !d || void 0,
      "data-disabled": d || void 0,
      "data-in-range": D && !d && !h || void 0,
      "data-first-in-range": r && !d || void 0,
      "data-last-in-range": o && !d || void 0,
      disabled: d
    }), m)
  );
});
qe.classes = ts;
qe.displayName = "@mantine/dates/PickerControl";
function ss(t, e, a) {
  return !e && !a ? !1 : !!(e && O(t).isBefore(e, "year") || a && O(t).isAfter(a, "year"));
}
function Ka(t, e, a, s) {
  const n = t.flat().filter(
    (c) => {
      var u;
      return !ss(c, e, a) && !((u = s == null ? void 0 : s(c)) != null && u.disabled);
    }
  ), l = n.find((c) => {
    var u;
    return (u = s == null ? void 0 : s(c)) == null ? void 0 : u.selected;
  });
  if (l)
    return l;
  const i = n.find((c) => O().isSame(c, "year"));
  return i || n[0];
}
function as(t) {
  const e = t.getFullYear(), a = e - e % 10;
  let s = 0;
  const n = [[], [], [], []];
  for (let l = 0; l < 4; l += 1) {
    const i = l === 3 ? 1 : 3;
    for (let c = 0; c < i; c += 1)
      n[l].push(new Date(a + s, 0)), s += 1;
  }
  return n;
}
var ns = { yearsList: "m_9206547b", yearsListCell: "m_c5a19c7d" };
const qa = {
  yearsListFormat: "YYYY",
  withCellSpacing: !0
}, Je = K((t, e) => {
  const a = J("YearsList", qa, t), M = a, {
    classNames: s,
    className: n,
    style: l,
    styles: i,
    unstyled: c,
    vars: u,
    decade: r,
    yearsListFormat: o,
    locale: D,
    minDate: v,
    maxDate: h,
    getYearControlProps: d,
    __staticSelector: m,
    __getControlRef: b,
    __onControlKeyDown: k,
    __onControlClick: N,
    __onControlMouseEnter: C,
    __preventFocus: R,
    __stopPropagation: F,
    withCellSpacing: S,
    size: A
  } = M, W = j(M, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "decade",
    "yearsListFormat",
    "locale",
    "minDate",
    "maxDate",
    "getYearControlProps",
    "__staticSelector",
    "__getControlRef",
    "__onControlKeyDown",
    "__onControlClick",
    "__onControlMouseEnter",
    "__preventFocus",
    "__stopPropagation",
    "withCellSpacing",
    "size"
  ]), P = he({
    name: m || "YearsList",
    classes: ns,
    props: a,
    className: n,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: u,
    rootSelector: "yearsList"
  }), z = le(), T = as(r), B = Ka(T, v, h, d), E = T.map((g, y) => {
    const w = g.map((p, L) => {
      const f = d == null ? void 0 : d(p), H = O(p).isSame(B, "year");
      return /* @__PURE__ */ x(
        "td",
        I(_({}, P("yearsListCell")), {
          "data-with-spacing": S || void 0,
          children: /* @__PURE__ */ x(
            qe,
            I(_(I(_({}, P("yearsListControl")), {
              size: A,
              unstyled: c,
              "data-mantine-stop-propagation": F || void 0,
              disabled: ss(p, v, h),
              ref: ($) => b == null ? void 0 : b(y, L, $)
            }), f), {
              onKeyDown: ($) => {
                var Y;
                (Y = f == null ? void 0 : f.onKeyDown) == null || Y.call(f, $), k == null || k($, { rowIndex: y, cellIndex: L, date: p });
              },
              onClick: ($) => {
                var Y;
                (Y = f == null ? void 0 : f.onClick) == null || Y.call(f, $), N == null || N($, p);
              },
              onMouseEnter: ($) => {
                var Y;
                (Y = f == null ? void 0 : f.onMouseEnter) == null || Y.call(f, $), C == null || C($, p);
              },
              onMouseDown: ($) => {
                var Y;
                (Y = f == null ? void 0 : f.onMouseDown) == null || Y.call(f, $), R && $.preventDefault();
              },
              tabIndex: R || !H ? -1 : 0,
              children: O(p).locale(z.getLocale(D)).format(o)
            })
          )
        }),
        L
      );
    });
    return /* @__PURE__ */ x("tr", I(_({}, P("yearsListRow")), { children: w }), y);
  });
  return /* @__PURE__ */ x(de, I(_(_({ component: "table", ref: e, size: A }, P("yearsList")), W), { children: /* @__PURE__ */ x("tbody", { children: E }) }));
});
Je.classes = ns;
Je.displayName = "@mantine/dates/YearsList";
function rs(t, e, a) {
  return !e && !a ? !1 : !!(e && O(t).isBefore(e, "month") || a && O(t).isAfter(a, "month"));
}
function Ja(t, e, a, s) {
  const n = t.flat().filter(
    (c) => {
      var u;
      return !rs(c, e, a) && !((u = s == null ? void 0 : s(c)) != null && u.disabled);
    }
  ), l = n.find((c) => {
    var u;
    return (u = s == null ? void 0 : s(c)) == null ? void 0 : u.selected;
  });
  if (l)
    return l;
  const i = n.find((c) => O().isSame(c, "month"));
  return i || n[0];
}
function Qa(t) {
  const e = O(t).startOf("year").toDate(), a = [[], [], [], []];
  let s = 0;
  for (let n = 0; n < 4; n += 1)
    for (let l = 0; l < 3; l += 1)
      a[n].push(O(e).add(s, "months").toDate()), s += 1;
  return a;
}
var os = { monthsList: "m_2a6c32d", monthsListCell: "m_fe27622f" };
const Xa = {
  monthsListFormat: "MMM",
  withCellSpacing: !0
}, Qe = K((t, e) => {
  const a = J("MonthsList", Xa, t), M = a, {
    classNames: s,
    className: n,
    style: l,
    styles: i,
    unstyled: c,
    vars: u,
    __staticSelector: r,
    year: o,
    monthsListFormat: D,
    locale: v,
    minDate: h,
    maxDate: d,
    getMonthControlProps: m,
    __getControlRef: b,
    __onControlKeyDown: k,
    __onControlClick: N,
    __onControlMouseEnter: C,
    __preventFocus: R,
    __stopPropagation: F,
    withCellSpacing: S,
    size: A
  } = M, W = j(M, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "__staticSelector",
    "year",
    "monthsListFormat",
    "locale",
    "minDate",
    "maxDate",
    "getMonthControlProps",
    "__getControlRef",
    "__onControlKeyDown",
    "__onControlClick",
    "__onControlMouseEnter",
    "__preventFocus",
    "__stopPropagation",
    "withCellSpacing",
    "size"
  ]), P = he({
    name: r || "MonthsList",
    classes: os,
    props: a,
    className: n,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: u,
    rootSelector: "monthsList"
  }), z = le(), T = Qa(o), B = Ja(T, h, d, m), E = T.map((g, y) => {
    const w = g.map((p, L) => {
      const f = m == null ? void 0 : m(p), H = O(p).isSame(B, "month");
      return /* @__PURE__ */ x(
        "td",
        I(_({}, P("monthsListCell")), {
          "data-with-spacing": S || void 0,
          children: /* @__PURE__ */ x(
            qe,
            I(_(I(_({}, P("monthsListControl")), {
              size: A,
              unstyled: c,
              __staticSelector: r || "MonthsList",
              "data-mantine-stop-propagation": F || void 0,
              disabled: rs(p, h, d),
              ref: ($) => b == null ? void 0 : b(y, L, $)
            }), f), {
              onKeyDown: ($) => {
                var Y;
                (Y = f == null ? void 0 : f.onKeyDown) == null || Y.call(f, $), k == null || k($, { rowIndex: y, cellIndex: L, date: p });
              },
              onClick: ($) => {
                var Y;
                (Y = f == null ? void 0 : f.onClick) == null || Y.call(f, $), N == null || N($, p);
              },
              onMouseEnter: ($) => {
                var Y;
                (Y = f == null ? void 0 : f.onMouseEnter) == null || Y.call(f, $), C == null || C($, p);
              },
              onMouseDown: ($) => {
                var Y;
                (Y = f == null ? void 0 : f.onMouseDown) == null || Y.call(f, $), R && $.preventDefault();
              },
              tabIndex: R || !H ? -1 : 0,
              children: O(p).locale(z.getLocale(v)).format(D)
            })
          )
        }),
        L
      );
    });
    return /* @__PURE__ */ x("tr", I(_({}, P("monthsListRow")), { children: w }), y);
  });
  return /* @__PURE__ */ x(de, I(_(_({ component: "table", ref: e, size: A }, P("monthsList")), W), { children: /* @__PURE__ */ x("tbody", { children: E }) }));
});
Qe.classes = os;
Qe.displayName = "@mantine/dates/MonthsList";
var is = { calendarHeader: "m_730a79ed", calendarHeaderLevel: "m_f6645d97", calendarHeaderControl: "m_2351eeb0", calendarHeaderControlIcon: "m_367dc749" };
const en = {
  nextDisabled: !1,
  previousDisabled: !1,
  hasNextLevel: !0,
  withNext: !0,
  withPrevious: !0
}, tn = ge((t, { size: e }) => ({
  calendarHeader: {
    "--dch-control-size": Ce(e, "dch-control-size"),
    "--dch-fz": Re(e)
  }
})), ve = K((t, e) => {
  const a = J("CalendarHeader", en, t), E = a, {
    classNames: s,
    className: n,
    style: l,
    styles: i,
    unstyled: c,
    vars: u,
    nextIcon: r,
    previousIcon: o,
    nextLabel: D,
    previousLabel: v,
    onNext: h,
    onPrevious: d,
    onLevelClick: m,
    label: b,
    nextDisabled: k,
    previousDisabled: N,
    hasNextLevel: C,
    levelControlAriaLabel: R,
    withNext: F,
    withPrevious: S,
    __staticSelector: A,
    __preventFocus: W,
    __stopPropagation: P
  } = E, z = j(E, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "onLevelClick",
    "label",
    "nextDisabled",
    "previousDisabled",
    "hasNextLevel",
    "levelControlAriaLabel",
    "withNext",
    "withPrevious",
    "__staticSelector",
    "__preventFocus",
    "__stopPropagation"
  ]), T = he({
    name: A || "CalendarHeader",
    classes: is,
    props: a,
    className: n,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: u,
    varsResolver: tn,
    rootSelector: "calendarHeader"
  }), B = W ? (M) => M.preventDefault() : void 0;
  return /* @__PURE__ */ ie(de, I(_(I(_({}, T("calendarHeader")), { ref: e }), z), { children: [
    S && /* @__PURE__ */ x(
      Me,
      I(_({}, T("calendarHeaderControl")), {
        "data-direction": "previous",
        "aria-label": v,
        onClick: d,
        unstyled: c,
        onMouseDown: B,
        disabled: N,
        "data-disabled": N || void 0,
        tabIndex: W || N ? -1 : 0,
        "data-mantine-stop-propagation": P || void 0,
        children: o || /* @__PURE__ */ x(
          gt,
          I(_({}, T("calendarHeaderControlIcon")), {
            "data-direction": "previous",
            size: "45%"
          })
        )
      })
    ),
    /* @__PURE__ */ x(
      Me,
      I(_({
        component: C ? "button" : "div"
      }, T("calendarHeaderLevel")), {
        onClick: C ? m : void 0,
        unstyled: c,
        onMouseDown: C ? B : void 0,
        disabled: !C,
        "data-static": !C || void 0,
        "aria-label": R,
        tabIndex: W || !C ? -1 : 0,
        "data-mantine-stop-propagation": P || void 0,
        children: b
      })
    ),
    F && /* @__PURE__ */ x(
      Me,
      I(_({}, T("calendarHeaderControl")), {
        "data-direction": "next",
        "aria-label": D,
        onClick: h,
        unstyled: c,
        onMouseDown: B,
        disabled: k,
        "data-disabled": k || void 0,
        tabIndex: W || k ? -1 : 0,
        "data-mantine-stop-propagation": P || void 0,
        children: r || /* @__PURE__ */ x(
          gt,
          I(_({}, T("calendarHeaderControlIcon")), {
            "data-direction": "next",
            size: "45%"
          })
        )
      })
    )
  ] }));
});
ve.classes = is;
ve.displayName = "@mantine/dates/CalendarHeader";
function sn(t) {
  const e = as(t);
  return [e[0][0], e[3][0]];
}
const an = {
  decadeLabelFormat: "YYYY"
}, Xe = K((t, e) => {
  const Z = J("DecadeLevel", an, t), {
    decade: s,
    locale: n,
    minDate: l,
    maxDate: i,
    yearsListFormat: c,
    getYearControlProps: u,
    __getControlRef: r,
    __onControlKeyDown: o,
    __onControlClick: D,
    __onControlMouseEnter: v,
    withCellSpacing: h,
    __preventFocus: d,
    nextIcon: m,
    previousIcon: b,
    nextLabel: k,
    previousLabel: N,
    onNext: C,
    onPrevious: R,
    nextDisabled: F,
    previousDisabled: S,
    levelControlAriaLabel: A,
    withNext: W,
    withPrevious: P,
    decadeLabelFormat: z,
    classNames: T,
    styles: B,
    unstyled: E,
    __staticSelector: M,
    __stopPropagation: g,
    size: y
  } = Z, w = j(Z, [
    // YearsList settings
    "decade",
    "locale",
    "minDate",
    "maxDate",
    "yearsListFormat",
    "getYearControlProps",
    "__getControlRef",
    "__onControlKeyDown",
    "__onControlClick",
    "__onControlMouseEnter",
    "withCellSpacing",
    // CalendarHeader settings
    "__preventFocus",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "nextDisabled",
    "previousDisabled",
    "levelControlAriaLabel",
    "withNext",
    "withPrevious",
    // Other props
    "decadeLabelFormat",
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "__stopPropagation",
    "size"
  ]), p = le(), [L, f] = sn(s), H = {
    __staticSelector: M || "DecadeLevel",
    classNames: T,
    styles: B,
    unstyled: E,
    size: y
  }, $ = typeof F == "boolean" ? F : i ? !O(f).endOf("year").isBefore(i) : !1, Y = typeof S == "boolean" ? S : l ? !O(L).startOf("year").isAfter(l) : !1, V = (ee, X) => O(ee).locale(n || p.locale).format(X);
  return /* @__PURE__ */ ie(de, I(_({ "data-decade-level": !0, size: y, ref: e }, w), { children: [
    /* @__PURE__ */ x(
      ve,
      _({
        label: typeof z == "function" ? z(L, f) : `${V(L, z)} – ${V(
          f,
          z
        )}`,
        __preventFocus: d,
        __stopPropagation: g,
        nextIcon: m,
        previousIcon: b,
        nextLabel: k,
        previousLabel: N,
        onNext: C,
        onPrevious: R,
        nextDisabled: $,
        previousDisabled: Y,
        hasNextLevel: !1,
        levelControlAriaLabel: A,
        withNext: W,
        withPrevious: P
      }, H)
    ),
    /* @__PURE__ */ x(
      Je,
      _({
        decade: s,
        locale: n,
        minDate: l,
        maxDate: i,
        yearsListFormat: c,
        getYearControlProps: u,
        __getControlRef: r,
        __onControlKeyDown: o,
        __onControlClick: D,
        __onControlMouseEnter: v,
        __preventFocus: d,
        __stopPropagation: g,
        withCellSpacing: h
      }, H)
    )
  ] }));
});
Xe.classes = _(_({}, Je.classes), ve.classes);
Xe.displayName = "@mantine/dates/DecadeLevel";
const nn = {
  yearLabelFormat: "YYYY"
}, et = K((t, e) => {
  const V = J("YearLevel", nn, t), {
    year: s,
    locale: n,
    minDate: l,
    maxDate: i,
    monthsListFormat: c,
    getMonthControlProps: u,
    __getControlRef: r,
    __onControlKeyDown: o,
    __onControlClick: D,
    __onControlMouseEnter: v,
    withCellSpacing: h,
    __preventFocus: d,
    nextIcon: m,
    previousIcon: b,
    nextLabel: k,
    previousLabel: N,
    onNext: C,
    onPrevious: R,
    onLevelClick: F,
    nextDisabled: S,
    previousDisabled: A,
    hasNextLevel: W,
    levelControlAriaLabel: P,
    withNext: z,
    withPrevious: T,
    yearLabelFormat: B,
    __staticSelector: E,
    __stopPropagation: M,
    size: g,
    classNames: y,
    styles: w,
    unstyled: p
  } = V, L = j(V, [
    // MonthsList settings
    "year",
    "locale",
    "minDate",
    "maxDate",
    "monthsListFormat",
    "getMonthControlProps",
    "__getControlRef",
    "__onControlKeyDown",
    "__onControlClick",
    "__onControlMouseEnter",
    "withCellSpacing",
    // CalendarHeader settings
    "__preventFocus",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "onLevelClick",
    "nextDisabled",
    "previousDisabled",
    "hasNextLevel",
    "levelControlAriaLabel",
    "withNext",
    "withPrevious",
    // Other props
    "yearLabelFormat",
    "__staticSelector",
    "__stopPropagation",
    "size",
    "classNames",
    "styles",
    "unstyled"
  ]), f = le(), H = {
    __staticSelector: E || "YearLevel",
    classNames: y,
    styles: w,
    unstyled: p,
    size: g
  }, $ = typeof S == "boolean" ? S : i ? !O(s).endOf("year").isBefore(i) : !1, Y = typeof A == "boolean" ? A : l ? !O(s).startOf("year").isAfter(l) : !1;
  return /* @__PURE__ */ ie(de, I(_({ "data-year-level": !0, size: g, ref: e }, L), { children: [
    /* @__PURE__ */ x(
      ve,
      _({
        label: typeof B == "function" ? B(s) : O(s).locale(n || f.locale).format(B),
        __preventFocus: d,
        __stopPropagation: M,
        nextIcon: m,
        previousIcon: b,
        nextLabel: k,
        previousLabel: N,
        onNext: C,
        onPrevious: R,
        onLevelClick: F,
        nextDisabled: $,
        previousDisabled: Y,
        hasNextLevel: W,
        levelControlAriaLabel: P,
        withNext: z,
        withPrevious: T
      }, H)
    ),
    /* @__PURE__ */ x(
      Qe,
      _({
        year: s,
        locale: n,
        minDate: l,
        maxDate: i,
        monthsListFormat: c,
        getMonthControlProps: u,
        __getControlRef: r,
        __onControlKeyDown: o,
        __onControlClick: D,
        __onControlMouseEnter: v,
        __preventFocus: d,
        __stopPropagation: M,
        withCellSpacing: h
      }, H)
    )
  ] }));
});
et.classes = _(_({}, ve.classes), Qe.classes);
et.displayName = "@mantine/dates/YearLevel";
const rn = {
  monthLabelFormat: "MMMM YYYY"
}, tt = K((t, e) => {
  const G = J("MonthLevel", rn, t), {
    month: s,
    locale: n,
    firstDayOfWeek: l,
    weekdayFormat: i,
    weekendDays: c,
    getDayProps: u,
    excludeDate: r,
    minDate: o,
    maxDate: D,
    renderDay: v,
    hideOutsideDates: h,
    hideWeekdays: d,
    getDayAriaLabel: m,
    __getDayRef: b,
    __onDayKeyDown: k,
    __onDayClick: N,
    __onDayMouseEnter: C,
    withCellSpacing: R,
    highlightToday: F,
    withWeekNumbers: S,
    __preventFocus: A,
    __stopPropagation: W,
    nextIcon: P,
    previousIcon: z,
    nextLabel: T,
    previousLabel: B,
    onNext: E,
    onPrevious: M,
    onLevelClick: g,
    nextDisabled: y,
    previousDisabled: w,
    hasNextLevel: p,
    levelControlAriaLabel: L,
    withNext: f,
    withPrevious: H,
    monthLabelFormat: $,
    classNames: Y,
    styles: V,
    unstyled: Z,
    __staticSelector: ee,
    size: X,
    static: Q
  } = G, re = j(G, [
    // Month settings
    "month",
    "locale",
    "firstDayOfWeek",
    "weekdayFormat",
    "weekendDays",
    "getDayProps",
    "excludeDate",
    "minDate",
    "maxDate",
    "renderDay",
    "hideOutsideDates",
    "hideWeekdays",
    "getDayAriaLabel",
    "__getDayRef",
    "__onDayKeyDown",
    "__onDayClick",
    "__onDayMouseEnter",
    "withCellSpacing",
    "highlightToday",
    "withWeekNumbers",
    // CalendarHeader settings
    "__preventFocus",
    "__stopPropagation",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "onLevelClick",
    "nextDisabled",
    "previousDisabled",
    "hasNextLevel",
    "levelControlAriaLabel",
    "withNext",
    "withPrevious",
    // Other props
    "monthLabelFormat",
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "size",
    "static"
  ]), U = le(), se = {
    __staticSelector: ee || "MonthLevel",
    classNames: Y,
    styles: V,
    unstyled: Z,
    size: X
  }, q = typeof y == "boolean" ? y : D ? !O(s).endOf("month").isBefore(D) : !1, te = typeof w == "boolean" ? w : o ? !O(s).startOf("month").isAfter(o) : !1;
  return /* @__PURE__ */ ie(de, I(_({ "data-month-level": !0, size: X, ref: e }, re), { children: [
    /* @__PURE__ */ x(
      ve,
      _({
        label: typeof $ == "function" ? $(s) : O(s).locale(n || U.locale).format($),
        __preventFocus: A,
        __stopPropagation: W,
        nextIcon: P,
        previousIcon: z,
        nextLabel: T,
        previousLabel: B,
        onNext: E,
        onPrevious: M,
        onLevelClick: g,
        nextDisabled: q,
        previousDisabled: te,
        hasNextLevel: p,
        levelControlAriaLabel: L,
        withNext: f,
        withPrevious: H
      }, se)
    ),
    /* @__PURE__ */ x(
      Ke,
      _({
        month: s,
        locale: n,
        firstDayOfWeek: l,
        weekdayFormat: i,
        weekendDays: c,
        getDayProps: u,
        excludeDate: r,
        minDate: o,
        maxDate: D,
        renderDay: v,
        hideOutsideDates: h,
        hideWeekdays: d,
        getDayAriaLabel: m,
        __getDayRef: b,
        __onDayKeyDown: k,
        __onDayClick: N,
        __onDayMouseEnter: C,
        __preventFocus: A,
        __stopPropagation: W,
        static: Q,
        withCellSpacing: R,
        highlightToday: F,
        withWeekNumbers: S
      }, se)
    )
  ] }));
});
tt.classes = _(_({}, Ke.classes), ve.classes);
tt.displayName = "@mantine/dates/MonthLevel";
var ls = { levelsGroup: "m_30b26e33" };
const on = {}, De = K((t, e) => {
  const a = J("LevelsGroup", on, t), v = a, { classNames: s, className: n, style: l, styles: i, unstyled: c, vars: u, __staticSelector: r } = v, o = j(v, ["classNames", "className", "style", "styles", "unstyled", "vars", "__staticSelector"]), D = he({
    name: r || "LevelsGroup",
    classes: ls,
    props: a,
    className: n,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: u,
    rootSelector: "levelsGroup"
  });
  return /* @__PURE__ */ x(de, _(_({ ref: e }, D("levelsGroup")), o));
});
De.classes = ls;
De.displayName = "@mantine/dates/LevelsGroup";
const ln = {
  numberOfColumns: 1
}, st = K((t, e) => {
  const p = J("DecadeLevelGroup", ln, t), {
    decade: s,
    locale: n,
    minDate: l,
    maxDate: i,
    yearsListFormat: c,
    getYearControlProps: u,
    __onControlClick: r,
    __onControlMouseEnter: o,
    withCellSpacing: D,
    __preventFocus: v,
    nextIcon: h,
    previousIcon: d,
    nextLabel: m,
    previousLabel: b,
    onNext: k,
    onPrevious: N,
    nextDisabled: C,
    previousDisabled: R,
    classNames: F,
    styles: S,
    unstyled: A,
    __staticSelector: W,
    __stopPropagation: P,
    numberOfColumns: z,
    levelControlAriaLabel: T,
    decadeLabelFormat: B,
    size: E,
    vars: M
  } = p, g = j(p, [
    // DecadeLevel settings
    "decade",
    "locale",
    "minDate",
    "maxDate",
    "yearsListFormat",
    "getYearControlProps",
    "__onControlClick",
    "__onControlMouseEnter",
    "withCellSpacing",
    // CalendarHeader settings
    "__preventFocus",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "nextDisabled",
    "previousDisabled",
    // Other settings
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "__stopPropagation",
    "numberOfColumns",
    "levelControlAriaLabel",
    "decadeLabelFormat",
    "size",
    "vars"
  ]), y = We([]), w = Array(z).fill(0).map((L, f) => {
    const H = O(s).add(f * 10, "years").toDate();
    return /* @__PURE__ */ x(
      Xe,
      {
        size: E,
        yearsListFormat: c,
        decade: H,
        withNext: f === z - 1,
        withPrevious: f === 0,
        decadeLabelFormat: B,
        __onControlClick: r,
        __onControlMouseEnter: o,
        __onControlKeyDown: ($, Y) => bt({
          levelIndex: f,
          rowIndex: Y.rowIndex,
          cellIndex: Y.cellIndex,
          event: $,
          controlsRef: y
        }),
        __getControlRef: ($, Y, V) => {
          Array.isArray(y.current[f]) || (y.current[f] = []), Array.isArray(y.current[f][$]) || (y.current[f][$] = []), y.current[f][$][Y] = V;
        },
        levelControlAriaLabel: typeof T == "function" ? T(H) : T,
        locale: n,
        minDate: l,
        maxDate: i,
        __preventFocus: v,
        __stopPropagation: P,
        nextIcon: h,
        previousIcon: d,
        nextLabel: m,
        previousLabel: b,
        onNext: k,
        onPrevious: N,
        nextDisabled: C,
        previousDisabled: R,
        getYearControlProps: u,
        __staticSelector: W || "DecadeLevelGroup",
        classNames: F,
        styles: S,
        unstyled: A,
        withCellSpacing: D
      },
      f
    );
  });
  return /* @__PURE__ */ x(
    De,
    I(_({
      classNames: F,
      styles: S,
      __staticSelector: W || "DecadeLevelGroup",
      ref: e,
      size: E,
      unstyled: A
    }, g), {
      children: w
    })
  );
});
st.classes = _(_({}, De.classes), Xe.classes);
st.displayName = "@mantine/dates/DecadeLevelGroup";
const cn = {
  numberOfColumns: 1
}, at = K((t, e) => {
  const f = J("YearLevelGroup", cn, t), {
    year: s,
    locale: n,
    minDate: l,
    maxDate: i,
    monthsListFormat: c,
    getMonthControlProps: u,
    __onControlClick: r,
    __onControlMouseEnter: o,
    withCellSpacing: D,
    __preventFocus: v,
    nextIcon: h,
    previousIcon: d,
    nextLabel: m,
    previousLabel: b,
    onNext: k,
    onPrevious: N,
    onLevelClick: C,
    nextDisabled: R,
    previousDisabled: F,
    hasNextLevel: S,
    classNames: A,
    styles: W,
    unstyled: P,
    __staticSelector: z,
    __stopPropagation: T,
    numberOfColumns: B,
    levelControlAriaLabel: E,
    yearLabelFormat: M,
    size: g,
    vars: y
  } = f, w = j(f, [
    // YearLevel settings
    "year",
    "locale",
    "minDate",
    "maxDate",
    "monthsListFormat",
    "getMonthControlProps",
    "__onControlClick",
    "__onControlMouseEnter",
    "withCellSpacing",
    // CalendarHeader settings
    "__preventFocus",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "onLevelClick",
    "nextDisabled",
    "previousDisabled",
    "hasNextLevel",
    // Other settings
    "classNames",
    "styles",
    "unstyled",
    "__staticSelector",
    "__stopPropagation",
    "numberOfColumns",
    "levelControlAriaLabel",
    "yearLabelFormat",
    "size",
    "vars"
  ]), p = We([]), L = Array(B).fill(0).map((H, $) => {
    const Y = O(s).add($, "years").toDate();
    return /* @__PURE__ */ x(
      et,
      {
        size: g,
        monthsListFormat: c,
        year: Y,
        withNext: $ === B - 1,
        withPrevious: $ === 0,
        yearLabelFormat: M,
        __stopPropagation: T,
        __onControlClick: r,
        __onControlMouseEnter: o,
        __onControlKeyDown: (V, Z) => bt({
          levelIndex: $,
          rowIndex: Z.rowIndex,
          cellIndex: Z.cellIndex,
          event: V,
          controlsRef: p
        }),
        __getControlRef: (V, Z, ee) => {
          Array.isArray(p.current[$]) || (p.current[$] = []), Array.isArray(p.current[$][V]) || (p.current[$][V] = []), p.current[$][V][Z] = ee;
        },
        levelControlAriaLabel: typeof E == "function" ? E(Y) : E,
        locale: n,
        minDate: l,
        maxDate: i,
        __preventFocus: v,
        nextIcon: h,
        previousIcon: d,
        nextLabel: m,
        previousLabel: b,
        onNext: k,
        onPrevious: N,
        onLevelClick: C,
        nextDisabled: R,
        previousDisabled: F,
        hasNextLevel: S,
        getMonthControlProps: u,
        classNames: A,
        styles: W,
        unstyled: P,
        __staticSelector: z || "YearLevelGroup",
        withCellSpacing: D
      },
      $
    );
  });
  return /* @__PURE__ */ x(
    De,
    I(_({
      classNames: A,
      styles: W,
      __staticSelector: z || "YearLevelGroup",
      ref: e,
      size: g,
      unstyled: P
    }, w), {
      children: L
    })
  );
});
at.classes = _(_({}, et.classes), De.classes);
at.displayName = "@mantine/dates/YearLevelGroup";
const un = {
  numberOfColumns: 1
}, nt = K((t, e) => {
  const U = J("MonthLevelGroup", un, t), {
    month: s,
    locale: n,
    firstDayOfWeek: l,
    weekdayFormat: i,
    weekendDays: c,
    getDayProps: u,
    excludeDate: r,
    minDate: o,
    maxDate: D,
    renderDay: v,
    hideOutsideDates: h,
    hideWeekdays: d,
    getDayAriaLabel: m,
    __onDayClick: b,
    __onDayMouseEnter: k,
    withCellSpacing: N,
    highlightToday: C,
    withWeekNumbers: R,
    __preventFocus: F,
    nextIcon: S,
    previousIcon: A,
    nextLabel: W,
    previousLabel: P,
    onNext: z,
    onPrevious: T,
    onLevelClick: B,
    nextDisabled: E,
    previousDisabled: M,
    hasNextLevel: g,
    classNames: y,
    styles: w,
    unstyled: p,
    numberOfColumns: L,
    levelControlAriaLabel: f,
    monthLabelFormat: H,
    __staticSelector: $,
    __stopPropagation: Y,
    size: V,
    static: Z,
    vars: ee
  } = U, X = j(U, [
    // Month settings
    "month",
    "locale",
    "firstDayOfWeek",
    "weekdayFormat",
    "weekendDays",
    "getDayProps",
    "excludeDate",
    "minDate",
    "maxDate",
    "renderDay",
    "hideOutsideDates",
    "hideWeekdays",
    "getDayAriaLabel",
    "__onDayClick",
    "__onDayMouseEnter",
    "withCellSpacing",
    "highlightToday",
    "withWeekNumbers",
    // CalendarHeader settings
    "__preventFocus",
    "nextIcon",
    "previousIcon",
    "nextLabel",
    "previousLabel",
    "onNext",
    "onPrevious",
    "onLevelClick",
    "nextDisabled",
    "previousDisabled",
    "hasNextLevel",
    // Other settings
    "classNames",
    "styles",
    "unstyled",
    "numberOfColumns",
    "levelControlAriaLabel",
    "monthLabelFormat",
    "__staticSelector",
    "__stopPropagation",
    "size",
    "static",
    "vars"
  ]), Q = We([]), re = Array(L).fill(0).map((se, q) => {
    const te = O(s).add(q, "months").toDate();
    return /* @__PURE__ */ x(
      tt,
      {
        month: te,
        withNext: q === L - 1,
        withPrevious: q === 0,
        monthLabelFormat: H,
        __stopPropagation: Y,
        __onDayClick: b,
        __onDayMouseEnter: k,
        __onDayKeyDown: (G, ce) => bt({
          levelIndex: q,
          rowIndex: ce.rowIndex,
          cellIndex: ce.cellIndex,
          event: G,
          controlsRef: Q
        }),
        __getDayRef: (G, ce, ae) => {
          Array.isArray(Q.current[q]) || (Q.current[q] = []), Array.isArray(Q.current[q][G]) || (Q.current[q][G] = []), Q.current[q][G][ce] = ae;
        },
        levelControlAriaLabel: typeof f == "function" ? f(te) : f,
        locale: n,
        firstDayOfWeek: l,
        weekdayFormat: i,
        weekendDays: c,
        getDayProps: u,
        excludeDate: r,
        minDate: o,
        maxDate: D,
        renderDay: v,
        hideOutsideDates: h,
        hideWeekdays: d,
        getDayAriaLabel: m,
        __preventFocus: F,
        nextIcon: S,
        previousIcon: A,
        nextLabel: W,
        previousLabel: P,
        onNext: z,
        onPrevious: T,
        onLevelClick: B,
        nextDisabled: E,
        previousDisabled: M,
        hasNextLevel: g,
        classNames: y,
        styles: w,
        unstyled: p,
        __staticSelector: $ || "MonthLevelGroup",
        size: V,
        static: Z,
        withCellSpacing: N,
        highlightToday: C,
        withWeekNumbers: R
      },
      q
    );
  });
  return /* @__PURE__ */ x(
    De,
    I(_({
      classNames: y,
      styles: w,
      __staticSelector: $ || "MonthLevelGroup",
      ref: e,
      size: V
    }, X), {
      children: re
    })
  );
});
nt.classes = _(_({}, De.classes), tt.classes);
nt.displayName = "@mantine/dates/MonthLevelGroup";
var cs = { input: "m_6fa5e2aa" };
const dn = {}, rt = K((t, e) => {
  const M = Hs("PickerInputBase", dn, t), {
    inputProps: a,
    wrapperProps: s,
    placeholder: n,
    classNames: l,
    styles: i,
    unstyled: c,
    popoverProps: u,
    modalProps: r,
    dropdownType: o,
    children: D,
    formattedValue: v,
    dropdownHandlers: h,
    dropdownOpened: d,
    onClick: m,
    clearable: b,
    onClear: k,
    clearButtonProps: N,
    rightSection: C,
    shouldClear: R,
    readOnly: F,
    disabled: S,
    value: A,
    name: W,
    form: P,
    type: z
  } = M, T = j(M, [
    "inputProps",
    "wrapperProps",
    "placeholder",
    "classNames",
    "styles",
    "unstyled",
    "popoverProps",
    "modalProps",
    "dropdownType",
    "children",
    "formattedValue",
    "dropdownHandlers",
    "dropdownOpened",
    "onClick",
    "clearable",
    "onClear",
    "clearButtonProps",
    "rightSection",
    "shouldClear",
    "readOnly",
    "disabled",
    "value",
    "name",
    "form",
    "type"
  ]), B = /* @__PURE__ */ x(xe.ClearButton, _({ onClick: k, unstyled: c }, N)), E = () => {
    z === "range" && Array.isArray(A) && A[0] && !A[1] && k(), h.close();
  };
  return /* @__PURE__ */ ie(Cs, { children: [
    o === "modal" && !F && /* @__PURE__ */ x(
      ue,
      I(_({
        opened: d,
        onClose: E,
        withCloseButton: !1,
        size: "auto",
        "data-dates-modal": !0,
        unstyled: c
      }, r), {
        children: D
      })
    ),
    /* @__PURE__ */ x(xe.Wrapper, I(_({}, s), { children: /* @__PURE__ */ ie(
      Dt,
      I(_({
        position: "bottom-start",
        opened: d,
        trapFocus: !0,
        returnFocus: !1,
        unstyled: c
      }, u), {
        disabled: (u == null ? void 0 : u.disabled) || o === "modal" || F,
        onChange: (g) => {
          var y;
          g || ((y = u == null ? void 0 : u.onClose) == null || y.call(u), E());
        },
        children: [
          /* @__PURE__ */ x(Dt.Target, { children: /* @__PURE__ */ x(
            xe,
            I(_(I(_({
              "data-dates-input": !0,
              "data-read-only": F || void 0,
              disabled: S,
              component: "button",
              type: "button",
              multiline: !0,
              onClick: (g) => {
                m == null || m(g), h.toggle();
              },
              __clearSection: B,
              __clearable: b && R && !F && !S,
              rightSection: C
            }, a), {
              ref: e,
              classNames: I(_({}, l), { input: zs(cs.input, l == null ? void 0 : l.input) })
            }), T), {
              children: v || /* @__PURE__ */ x(
                xe.Placeholder,
                {
                  error: a.error,
                  unstyled: c,
                  className: l == null ? void 0 : l.placeholder,
                  style: i == null ? void 0 : i.placeholder,
                  children: n
                }
              )
            })
          ) }),
          /* @__PURE__ */ x(Dt.Dropdown, { "data-dates-dropdown": !0, children: D })
        ]
      })
    ) })),
    /* @__PURE__ */ x(Zt, { value: A, name: W, form: P, type: z })
  ] });
});
rt.classes = cs;
rt.displayName = "@mantine/dates/PickerInputBase";
const Bt = (t) => t === "range" ? [null, null] : t === "multiple" ? [] : null;
function wt({
  type: t,
  value: e,
  defaultValue: a,
  onChange: s,
  applyTimezone: n = !0
}) {
  const l = We(t), i = le(), [c, u, r] = Ut({
    value: me("add", e, i.getTimezone(), !n),
    defaultValue: me("add", a, i.getTimezone(), !n),
    finalValue: Bt(t),
    onChange: (D) => {
      s == null || s(me("remove", D, i.getTimezone(), !n));
    }
  });
  let o = c;
  if (l.current !== t) {
    if (l.current = t, e === void 0)
      o = a !== void 0 ? a : Bt(t), u(o);
    else if (process.env.NODE_ENV === "development")
      switch (t) {
        case "default":
          e !== null && typeof e != "string" && console.error(
            "[@mantine/dates/use-uncontrolled-dates] Value must be type of `null` or `string`"
          );
          break;
        case "multiple":
          e instanceof Array || console.error(
            "[@mantine/dates/use-uncontrolled-dates] Value must be type of `string[]`"
          );
          break;
        case "range":
          (!(e instanceof Array) || e.length !== 2) && console.error(
            "[@mantine/dates/use-uncontrolled-dates] Value must be type of `[string, string]`"
          );
          break;
      }
  }
  return [o, u, r];
}
function _t(t, e) {
  return t ? t === "month" ? 0 : t === "year" ? 1 : 2 : e || 0;
}
function fn(t) {
  return t === 0 ? "month" : t === 1 ? "year" : "decade";
}
function we(t, e, a) {
  return fn(
    Rs(
      _t(t, 0),
      _t(e, 0),
      _t(a, 2)
    )
  );
}
const mn = {
  maxLevel: "decade",
  minLevel: "month",
  __updateDateOnYearSelect: !0,
  __updateDateOnMonthSelect: !0
}, ot = K((t, e) => {
  var Lt, Ot, xt, Nt, Tt, At;
  const a = J("Calendar", mn, t), Ct = a, {
    vars: s,
    maxLevel: n,
    minLevel: l,
    defaultLevel: i,
    level: c,
    onLevelChange: u,
    date: r,
    defaultDate: o,
    onDateChange: D,
    numberOfColumns: v,
    columnsToScroll: h,
    ariaLabels: d,
    nextLabel: m,
    previousLabel: b,
    onYearSelect: k,
    onMonthSelect: N,
    onYearMouseEnter: C,
    onMonthMouseEnter: R,
    __updateDateOnYearSelect: F,
    __updateDateOnMonthSelect: S,
    firstDayOfWeek: A,
    weekdayFormat: W,
    weekendDays: P,
    getDayProps: z,
    excludeDate: T,
    renderDay: B,
    hideOutsideDates: E,
    hideWeekdays: M,
    getDayAriaLabel: g,
    monthLabelFormat: y,
    nextIcon: w,
    previousIcon: p,
    __onDayClick: L,
    __onDayMouseEnter: f,
    withCellSpacing: H,
    highlightToday: $,
    withWeekNumbers: Y,
    monthsListFormat: V,
    getMonthControlProps: Z,
    yearLabelFormat: ee,
    yearsListFormat: X,
    getYearControlProps: Q,
    decadeLabelFormat: re,
    classNames: U,
    styles: se,
    unstyled: q,
    minDate: te,
    maxDate: G,
    locale: ce,
    __staticSelector: ae,
    size: oe,
    __preventFocus: lt,
    __stopPropagation: ct,
    onNextDecade: ut,
    onPreviousDecade: dt,
    onNextYear: ft,
    onPreviousYear: mt,
    onNextMonth: ht,
    onPreviousMonth: pt,
    static: us,
    __timezoneApplied: ds
  } = Ct, fs = j(Ct, [
    "vars",
    // CalendarLevel props
    "maxLevel",
    "minLevel",
    "defaultLevel",
    "level",
    "onLevelChange",
    "date",
    "defaultDate",
    "onDateChange",
    "numberOfColumns",
    "columnsToScroll",
    "ariaLabels",
    "nextLabel",
    "previousLabel",
    "onYearSelect",
    "onMonthSelect",
    "onYearMouseEnter",
    "onMonthMouseEnter",
    "__updateDateOnYearSelect",
    "__updateDateOnMonthSelect",
    // MonthLevelGroup props
    "firstDayOfWeek",
    "weekdayFormat",
    "weekendDays",
    "getDayProps",
    "excludeDate",
    "renderDay",
    "hideOutsideDates",
    "hideWeekdays",
    "getDayAriaLabel",
    "monthLabelFormat",
    "nextIcon",
    "previousIcon",
    "__onDayClick",
    "__onDayMouseEnter",
    "withCellSpacing",
    "highlightToday",
    "withWeekNumbers",
    // YearLevelGroup props
    "monthsListFormat",
    "getMonthControlProps",
    "yearLabelFormat",
    // DecadeLevelGroup props
    "yearsListFormat",
    "getYearControlProps",
    "decadeLabelFormat",
    // Other props
    "classNames",
    "styles",
    "unstyled",
    "minDate",
    "maxDate",
    "locale",
    "__staticSelector",
    "size",
    "__preventFocus",
    "__stopPropagation",
    "onNextDecade",
    "onPreviousDecade",
    "onNextYear",
    "onPreviousYear",
    "onNextMonth",
    "onPreviousMonth",
    "static",
    "__timezoneApplied"
  ]), { resolvedClassNames: ms, resolvedStyles: hs } = He({
    classNames: U,
    styles: se,
    props: a
  }), [yt, Le] = Ut({
    value: c ? we(c, l, n) : void 0,
    defaultValue: i ? we(i, l, n) : void 0,
    finalValue: we(void 0, l, n),
    onChange: u
  }), [ps, ye] = wt({
    type: "default",
    value: r,
    defaultValue: o,
    onChange: D,
    applyTimezone: !ds
  }), vt = {
    __staticSelector: ae || "Calendar",
    styles: hs,
    classNames: ms,
    unstyled: q,
    size: oe
  }, ys = le(), _e = h || v || 1, kt = /* @__PURE__ */ new Date(), vs = te && te > kt ? te : kt, fe = ps || me("add", vs, ys.getTimezone()), Ds = () => {
    const ne = O(fe).add(_e, "month").toDate();
    ht == null || ht(ne), ye(ne);
  }, _s = () => {
    const ne = O(fe).subtract(_e, "month").toDate();
    pt == null || pt(ne), ye(ne);
  }, gs = () => {
    const ne = O(fe).add(_e, "year").toDate();
    ft == null || ft(ne), ye(ne);
  }, bs = () => {
    const ne = O(fe).subtract(_e, "year").toDate();
    mt == null || mt(ne), ye(ne);
  }, Ss = () => {
    const ne = O(fe).add(10 * _e, "year").toDate();
    ut == null || ut(ne), ye(ne);
  }, $s = () => {
    const ne = O(fe).subtract(10 * _e, "year").toDate();
    dt == null || dt(ne), ye(ne);
  };
  return /* @__PURE__ */ ie(de, I(_({ ref: e, size: oe, "data-calendar": !0 }, fs), { children: [
    yt === "month" && /* @__PURE__ */ x(
      nt,
      _({
        month: fe,
        minDate: te,
        maxDate: G,
        firstDayOfWeek: A,
        weekdayFormat: W,
        weekendDays: P,
        getDayProps: z,
        excludeDate: T,
        renderDay: B,
        hideOutsideDates: E,
        hideWeekdays: M,
        getDayAriaLabel: g,
        onNext: Ds,
        onPrevious: _s,
        hasNextLevel: n !== "month",
        onLevelClick: () => Le("year"),
        numberOfColumns: v,
        locale: ce,
        levelControlAriaLabel: d == null ? void 0 : d.monthLevelControl,
        nextLabel: (Lt = d == null ? void 0 : d.nextMonth) != null ? Lt : m,
        nextIcon: w,
        previousLabel: (Ot = d == null ? void 0 : d.previousMonth) != null ? Ot : b,
        previousIcon: p,
        monthLabelFormat: y,
        __onDayClick: L,
        __onDayMouseEnter: f,
        __preventFocus: lt,
        __stopPropagation: ct,
        static: us,
        withCellSpacing: H,
        highlightToday: $,
        withWeekNumbers: Y
      }, vt)
    ),
    yt === "year" && /* @__PURE__ */ x(
      at,
      _({
        year: fe,
        numberOfColumns: v,
        minDate: te,
        maxDate: G,
        monthsListFormat: V,
        getMonthControlProps: Z,
        locale: ce,
        onNext: gs,
        onPrevious: bs,
        hasNextLevel: n !== "month" && n !== "year",
        onLevelClick: () => Le("decade"),
        levelControlAriaLabel: d == null ? void 0 : d.yearLevelControl,
        nextLabel: (xt = d == null ? void 0 : d.nextYear) != null ? xt : m,
        nextIcon: w,
        previousLabel: (Nt = d == null ? void 0 : d.previousYear) != null ? Nt : b,
        previousIcon: p,
        yearLabelFormat: ee,
        __onControlMouseEnter: R,
        __onControlClick: (ne, Se) => {
          S && ye(Se), Le(we("month", l, n)), N == null || N(Se);
        },
        __preventFocus: lt,
        __stopPropagation: ct,
        withCellSpacing: H
      }, vt)
    ),
    yt === "decade" && /* @__PURE__ */ x(
      st,
      _({
        decade: fe,
        minDate: te,
        maxDate: G,
        yearsListFormat: X,
        getYearControlProps: Q,
        locale: ce,
        onNext: Ss,
        onPrevious: $s,
        numberOfColumns: v,
        nextLabel: (Tt = d == null ? void 0 : d.nextDecade) != null ? Tt : m,
        nextIcon: w,
        previousLabel: (At = d == null ? void 0 : d.previousDecade) != null ? At : b,
        previousIcon: p,
        decadeLabelFormat: re,
        __onControlMouseEnter: C,
        __onControlClick: (ne, Se) => {
          F && ye(Se), Le(we("year", l, n)), k == null || k(Se);
        },
        __preventFocus: lt,
        __stopPropagation: ct,
        withCellSpacing: H
      }, vt)
    )
  ] }));
});
ot.classes = _(_(_({}, st.classes), at.classes), nt.classes);
ot.displayName = "@mantine/dates/Calendar";
function hn(t) {
  const oe = t, {
    maxLevel: e,
    minLevel: a,
    defaultLevel: s,
    level: n,
    onLevelChange: l,
    nextIcon: i,
    previousIcon: c,
    date: u,
    defaultDate: r,
    onDateChange: o,
    numberOfColumns: D,
    columnsToScroll: v,
    ariaLabels: h,
    nextLabel: d,
    previousLabel: m,
    onYearSelect: b,
    onMonthSelect: k,
    onYearMouseEnter: N,
    onMonthMouseEnter: C,
    onNextMonth: R,
    onPreviousMonth: F,
    onNextYear: S,
    onPreviousYear: A,
    onNextDecade: W,
    onPreviousDecade: P,
    withCellSpacing: z,
    highlightToday: T,
    __updateDateOnYearSelect: B,
    __updateDateOnMonthSelect: E,
    withWeekNumbers: M,
    firstDayOfWeek: g,
    weekdayFormat: y,
    weekendDays: w,
    getDayProps: p,
    excludeDate: L,
    renderDay: f,
    hideOutsideDates: H,
    hideWeekdays: $,
    getDayAriaLabel: Y,
    monthLabelFormat: V,
    monthsListFormat: Z,
    getMonthControlProps: ee,
    yearLabelFormat: X,
    yearsListFormat: Q,
    getYearControlProps: re,
    decadeLabelFormat: U,
    allowSingleDateInRange: se,
    allowDeselect: q,
    minDate: te,
    maxDate: G,
    locale: ce
  } = oe, ae = j(oe, [
    "maxLevel",
    "minLevel",
    "defaultLevel",
    "level",
    "onLevelChange",
    "nextIcon",
    "previousIcon",
    "date",
    "defaultDate",
    "onDateChange",
    "numberOfColumns",
    "columnsToScroll",
    "ariaLabels",
    "nextLabel",
    "previousLabel",
    "onYearSelect",
    "onMonthSelect",
    "onYearMouseEnter",
    "onMonthMouseEnter",
    "onNextMonth",
    "onPreviousMonth",
    "onNextYear",
    "onPreviousYear",
    "onNextDecade",
    "onPreviousDecade",
    "withCellSpacing",
    "highlightToday",
    "__updateDateOnYearSelect",
    "__updateDateOnMonthSelect",
    "withWeekNumbers",
    // MonthLevelGroup props
    "firstDayOfWeek",
    "weekdayFormat",
    "weekendDays",
    "getDayProps",
    "excludeDate",
    "renderDay",
    "hideOutsideDates",
    "hideWeekdays",
    "getDayAriaLabel",
    "monthLabelFormat",
    // YearLevelGroup props
    "monthsListFormat",
    "getMonthControlProps",
    "yearLabelFormat",
    // DecadeLevelGroup props
    "yearsListFormat",
    "getYearControlProps",
    "decadeLabelFormat",
    // External picker props
    "allowSingleDateInRange",
    "allowDeselect",
    // Other props
    "minDate",
    "maxDate",
    "locale"
  ]);
  return {
    calendarProps: {
      maxLevel: e,
      minLevel: a,
      defaultLevel: s,
      level: n,
      onLevelChange: l,
      nextIcon: i,
      previousIcon: c,
      date: u,
      defaultDate: r,
      onDateChange: o,
      numberOfColumns: D,
      columnsToScroll: v,
      ariaLabels: h,
      nextLabel: d,
      previousLabel: m,
      onYearSelect: b,
      onMonthSelect: k,
      onYearMouseEnter: N,
      onMonthMouseEnter: C,
      onNextMonth: R,
      onPreviousMonth: F,
      onNextYear: S,
      onPreviousYear: A,
      onNextDecade: W,
      onPreviousDecade: P,
      withCellSpacing: z,
      highlightToday: T,
      __updateDateOnYearSelect: B,
      __updateDateOnMonthSelect: E,
      withWeekNumbers: M,
      // MonthLevelGroup props
      firstDayOfWeek: g,
      weekdayFormat: y,
      weekendDays: w,
      getDayProps: p,
      excludeDate: L,
      renderDay: f,
      hideOutsideDates: H,
      hideWeekdays: $,
      getDayAriaLabel: Y,
      monthLabelFormat: V,
      // YearLevelGroup props
      monthsListFormat: Z,
      getMonthControlProps: ee,
      yearLabelFormat: X,
      // DecadeLevelGroup props
      yearsListFormat: Q,
      getYearControlProps: re,
      decadeLabelFormat: U,
      // External picker props
      allowSingleDateInRange: se,
      allowDeselect: q,
      // Other props
      minDate: te,
      maxDate: G,
      locale: ce
    },
    others: ae
  };
}
function Et(t, e) {
  const a = [...e].sort((s, n) => s.getTime() - n.getTime());
  return O(a[0]).startOf("day").subtract(1, "ms").isBefore(t) && O(a[1]).endOf("day").add(1, "ms").isAfter(t);
}
function pn({
  type: t,
  level: e,
  value: a,
  defaultValue: s,
  onChange: n,
  allowSingleDateInRange: l,
  allowDeselect: i,
  onMouseLeave: c,
  applyTimezone: u = !0
}) {
  const [r, o] = wt({
    type: t,
    value: a,
    defaultValue: s,
    onChange: n,
    applyTimezone: u
  }), [D, v] = ze(
    t === "range" && r[0] && !r[1] ? r[0] : null
  ), [h, d] = ze(null), m = (S) => {
    if (t === "range") {
      if (D instanceof Date && !r[1]) {
        if (O(S).isSame(D, e) && !l) {
          v(null), d(null), o([null, null]);
          return;
        }
        const A = [S, D];
        A.sort((W, P) => W.getTime() - P.getTime()), o(A), d(null), v(null);
        return;
      }
      if (r[0] && !r[1] && O(S).isSame(r[0], e) && !l) {
        v(null), d(null), o([null, null]);
        return;
      }
      o([S, null]), d(null), v(S);
      return;
    }
    if (t === "multiple") {
      r.some((A) => O(A).isSame(S, e)) ? o(r.filter((A) => !O(A).isSame(S, e))) : o([...r, S]);
      return;
    }
    r && i && O(S).isSame(r, e) ? o(null) : o(S);
  }, b = (S) => D instanceof Date && h instanceof Date ? Et(S, [h, D]) : r[0] instanceof Date && r[1] instanceof Date ? Et(S, r) : !1, k = t === "range" ? (S) => {
    c == null || c(S), d(null);
  } : c, N = (S) => r[0] instanceof Date && O(S).isSame(r[0], e) ? !(h && O(h).isBefore(r[0])) : !1, C = (S) => r[1] instanceof Date ? O(S).isSame(r[1], e) : !(r[0] instanceof Date) || !h ? !1 : O(h).isBefore(r[0]) && O(S).isSame(r[0], e), R = (S) => {
    if (t === "range")
      return {
        selected: r.some(
          (W) => W && O(W).isSame(S, e)
        ),
        inRange: b(S),
        firstInRange: N(S),
        lastInRange: C(S),
        "data-autofocus": !!r[0] && O(r[0]).isSame(S, e) || void 0
      };
    if (t === "multiple")
      return {
        selected: r.some(
          (W) => W && O(W).isSame(S, e)
        ),
        "data-autofocus": !!r[0] && O(r[0]).isSame(S, e) || void 0
      };
    const A = O(r).isSame(S, e);
    return { selected: A, "data-autofocus": A || void 0 };
  }, F = t === "range" && D ? d : () => {
  };
  return Vt(() => {
    if (t === "range")
      if (r[0] && !r[1] && (D == null ? void 0 : D.getTime()) !== r[0].getTime())
        v(r[0]);
      else {
        const S = r[0] == null && r[1] == null, A = r[0] != null && r[1] != null;
        (S || A) && (v(null), d(null));
      }
  }, [r]), {
    onDateChange: m,
    onRootMouseLeave: k,
    onHoveredDateChange: F,
    getControlProps: R,
    _value: r,
    setValue: o
  };
}
const yn = {
  type: "default",
  defaultLevel: "month",
  numberOfColumns: 1
}, it = K((t, e) => {
  const a = J("DatePicker", yn, t), B = a, {
    classNames: s,
    styles: n,
    vars: l,
    type: i,
    defaultValue: c,
    value: u,
    onChange: r,
    __staticSelector: o,
    getDayProps: D,
    allowSingleDateInRange: v,
    allowDeselect: h,
    onMouseLeave: d,
    numberOfColumns: m,
    hideOutsideDates: b,
    __onDayMouseEnter: k,
    __onDayClick: N,
    __timezoneApplied: C
  } = B, R = j(B, [
    "classNames",
    "styles",
    "vars",
    "type",
    "defaultValue",
    "value",
    "onChange",
    "__staticSelector",
    "getDayProps",
    "allowSingleDateInRange",
    "allowDeselect",
    "onMouseLeave",
    "numberOfColumns",
    "hideOutsideDates",
    "__onDayMouseEnter",
    "__onDayClick",
    "__timezoneApplied"
  ]), { onDateChange: F, onRootMouseLeave: S, onHoveredDateChange: A, getControlProps: W } = pn({
    type: i,
    level: "day",
    allowDeselect: h,
    allowSingleDateInRange: v,
    value: u,
    defaultValue: c,
    onChange: r,
    onMouseLeave: d,
    applyTimezone: !C
  }), { resolvedClassNames: P, resolvedStyles: z } = He({
    classNames: s,
    styles: n,
    props: a
  }), T = le();
  return /* @__PURE__ */ x(
    ot,
    I(_({
      ref: e,
      minLevel: "month",
      classNames: P,
      styles: z,
      __staticSelector: o || "DatePicker",
      onMouseLeave: S,
      numberOfColumns: m,
      hideOutsideDates: b != null ? b : m !== 1,
      __onDayMouseEnter: (E, M) => {
        A(M), k == null || k(E, M);
      },
      __onDayClick: (E, M) => {
        F(M), N == null || N(E, M);
      },
      getDayProps: (E) => _(_({}, W(E)), D == null ? void 0 : D(E))
    }, R), {
      date: me("add", R.date, T.getTimezone(), C),
      __timezoneApplied: !0
    })
  );
});
it.classes = ot.classes;
it.displayName = "@mantine/dates/DatePicker";
function vn({
  type: t,
  value: e,
  defaultValue: a,
  onChange: s,
  locale: n,
  format: l,
  closeOnChange: i,
  sortDates: c,
  labelSeparator: u,
  valueFormatter: r
}) {
  const o = le(), [D, v] = Fs(!1), [h, d] = wt({
    type: t,
    value: e,
    defaultValue: a,
    onChange: s
  }), m = ha({
    type: t,
    date: h,
    locale: o.getLocale(n),
    format: l,
    labelSeparator: o.getLabelSeparator(u),
    formatter: r
  }), b = (C) => {
    i && (t === "default" && v.close(), t === "range" && C[0] && C[1] && v.close()), d(c && t === "multiple" ? [...C].sort((R, F) => R.getTime() - F.getTime()) : C);
  }, k = () => b(t === "range" ? [null, null] : t === "multiple" ? [] : null), N = t === "range" ? !!h[0] : t === "multiple" ? h.length > 0 : h !== null;
  return {
    _value: h,
    setValue: b,
    onClear: k,
    shouldClear: N,
    formattedValue: m,
    dropdownOpened: D,
    dropdownHandlers: v
  };
}
const Dn = {
  type: "default",
  valueFormat: "MMMM D, YYYY",
  closeOnChange: !0,
  sortDates: !0,
  dropdownType: "popover"
}, Mt = K(
  (t, e) => {
    const a = J("DatePickerInput", Dn, t), H = a, {
      type: s,
      value: n,
      defaultValue: l,
      onChange: i,
      valueFormat: c,
      labelSeparator: u,
      locale: r,
      classNames: o,
      styles: D,
      unstyled: v,
      closeOnChange: h,
      size: d,
      variant: m,
      dropdownType: b,
      sortDates: k,
      minDate: N,
      maxDate: C,
      vars: R,
      defaultDate: F,
      valueFormatter: S
    } = H, A = j(H, [
      "type",
      "value",
      "defaultValue",
      "onChange",
      "valueFormat",
      "labelSeparator",
      "locale",
      "classNames",
      "styles",
      "unstyled",
      "closeOnChange",
      "size",
      "variant",
      "dropdownType",
      "sortDates",
      "minDate",
      "maxDate",
      "vars",
      "defaultDate",
      "valueFormatter"
    ]), { resolvedClassNames: W, resolvedStyles: P } = He({
      classNames: o,
      styles: D,
      props: a
    }), { calendarProps: z, others: T } = hn(A), {
      _value: B,
      setValue: E,
      formattedValue: M,
      dropdownHandlers: g,
      dropdownOpened: y,
      onClear: w,
      shouldClear: p
    } = vn({
      type: s,
      value: n,
      defaultValue: l,
      onChange: i,
      locale: r,
      format: c,
      labelSeparator: u,
      closeOnChange: h,
      sortDates: k,
      valueFormatter: S
    }), L = Array.isArray(B) ? B[0] || F : B || F, f = le();
    return /* @__PURE__ */ x(
      rt,
      I(_({
        formattedValue: M,
        dropdownOpened: y,
        dropdownHandlers: g,
        classNames: W,
        styles: P,
        unstyled: v,
        ref: e,
        onClear: w,
        shouldClear: p,
        value: B,
        size: d,
        variant: m,
        dropdownType: b
      }, T), {
        type: s,
        __staticSelector: "DatePickerInput",
        children: /* @__PURE__ */ x(
          it,
          I(_({}, z), {
            size: d,
            variant: m,
            type: s,
            value: B,
            defaultDate: L || Ca({ maxDate: C, minDate: N, timezone: f.getTimezone() }),
            onChange: E,
            locale: r,
            classNames: W,
            styles: P,
            unstyled: v,
            __staticSelector: "DatePickerInput",
            __stopPropagation: b === "popover",
            minDate: N,
            maxDate: C,
            date: me("add", z.date, f.getTimezone()),
            __timezoneApplied: !0
          })
        )
      })
    );
  }
);
Mt.classes = _(_({}, rt.classes), it.classes);
Mt.displayName = "@mantine/dates/DatePickerInput";
const _n = "DatePicker-module__DatePicker___I6PlB", gn = "DatePicker-module__input___PuEws", bn = "DatePicker-module__description___-jp8i", Sn = "DatePicker-module__calendarHeader___cBSbk", $n = "DatePicker-module__monthCell___-9BFY", wn = "DatePicker-module__yearCell___pJudu", Mn = "DatePicker-module__day___2-Ir3", kn = "DatePicker-module__calendarHeaderControl___MjI1T", Cn = "DatePicker-module__calendarHeaderLevel___VI5VQ", Ln = "DatePicker-module__weekday___4UDby", On = "DatePicker-module__rangeDropdown___LThPX", Ne = {
  DatePicker: _n,
  input: gn,
  description: bn,
  calendarHeader: Sn,
  monthCell: $n,
  yearCell: wn,
  day: Mn,
  calendarHeaderControl: kn,
  calendarHeaderLevel: Cn,
  weekday: Ln,
  rangeDropdown: On
}, xn = xs((t, e) => {
  const N = t, {
    "data-plum-id": a,
    leftSection: s = /* @__PURE__ */ x(Ns, { size: 14 }),
    nextIcon: n = /* @__PURE__ */ x(Ts, { size: 10 }),
    previousIcon: l = /* @__PURE__ */ x(As, { size: 10 }),
    valueFormat: i = "MMM DD, YYYY",
    size: c = "sm",
    clearable: u = !0,
    label: r,
    description: o,
    error: D,
    variant: v = "single",
    value: h,
    onChange: d
  } = N, m = j(N, [
    "data-plum-id",
    "leftSection",
    "nextIcon",
    "previousIcon",
    "valueFormat",
    "size",
    "clearable",
    "label",
    "description",
    "error",
    "variant",
    "value",
    "onChange"
  ]), b = v === "range" ? "range" : "default", k = v === "range" ? 2 : 1;
  return /* @__PURE__ */ ie("div", { className: Ne.DatePicker, "data-dates-variant": v, ref: e, children: [
    /* @__PURE__ */ x(
      Mt,
      _({
        classNames: Ne,
        "data-plum-id": a,
        popoverProps: {
          "data-dates-dropdown": !0,
          "data-dates-range": v === "range",
          classNames: {
            dropdown: v === "range" ? Ne.rangeDropdown : void 0
          }
        },
        leftSection: s,
        nextIcon: n,
        previousIcon: l,
        valueFormat: i,
        size: c,
        clearable: u,
        label: /* @__PURE__ */ x(Ys, { label: r }),
        type: b,
        allowDeselect: !0,
        error: D,
        placeholder: v === "range" ? "Select dates" : "Select a date",
        weekdayFormat: (C) => new Date(C).toLocaleDateString("en-US", { weekday: "long" }).charAt(0),
        weekendDays: [0],
        numberOfColumns: k,
        value: h,
        onChange: d
      }, m)
    ),
    o && !D && /* @__PURE__ */ x("div", { className: Ne.description, children: o })
  ] });
});
xn.displayName = "DatePicker";
export {
  xn as DatePicker
};
